/* eslint-disable */
import { useState, useRef, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

// ─── Supabase ─────────────────────────────────────────────────────────────────
const supabase = createClient(
  "https://ypxtvodxidwljpahviyr.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlweHR2b2R4aWR3bGpwYWh2aXlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4OTg3MjEsImV4cCI6MjA4OTQ3NDcyMX0.-n63VL73fKxf5kfxPr9xZEqBMSOMiWgfc3TtiZ_OWPk"
);

// ─── Fonts + CSS ──────────────────────────────────────────────────────────────
const FontLink = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;1,9..40,300&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    :root {
      --bg:#0a0b0e;--bg2:#111318;--bg3:#181b22;--bg4:#1e222c;
      --border:#252933;--border2:#2e3340;
      --accent:#b8f94e;--accent2:#96d93a;
      --text:#eef0f6;--text2:#8b90a0;--text3:#565c6e;
      --danger:#f45b5b;--warn:#f5a623;--info:#4e9cf9;
      --triage:#f5a623;--sale:#b8f94e;--support:#4e9cf9;
      --font-display:'Syne',sans-serif;--font-body:'DM Sans',sans-serif;
      --r:8px;--r2:12px;--r3:16px;
    }
    body{background:var(--bg);color:var(--text);font-family:var(--font-body);font-size:14px;line-height:1.6}
    button{cursor:pointer;font-family:var(--font-body)}
    input,textarea,select{font-family:var(--font-body)}
    ::-webkit-scrollbar{width:4px;height:4px}
    ::-webkit-scrollbar-track{background:transparent}
    ::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px}
    @keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes pulse{0%,100%{opacity:.4}50%{opacity:1}}
  `}</style>
);

// ─── Helpers ──────────────────────────────────────────────────────────────────
const fmt = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v);
const uid = () => Math.random().toString(36).slice(2, 9); // eslint-disable-line no-unused-vars

function formatProductForPrompt(p) {
  if (!p.tiers || p.tiers.length === 0) return `- ${p.name} — ${p.description}`;
  if (p.pricing_type === "package") {
    const tiers = p.tiers.map(t => `pacote ${t.qty}un = ${fmt(t.price)}`).join(" | ");
    return `- ${p.name} (pacotes fechados): ${tiers} — ${p.description}`;
  }
  if (p.tiers.length === 1) return `- ${p.name}: ${fmt(p.tiers[0].price)} — ${p.description}`;
  const tiers = p.tiers.map((t, i) => {
    const next = p.tiers[i + 1];
    if (!next) return `${t.qty}+ un: ${fmt(t.price)}/un`;
    return `${t.qty}-${next.qty - 1} un: ${fmt(t.price)}/un`;
  }).join(" | ");
  return `- ${p.name}: ${tiers} — ${p.description}`;
}

function buildSystemPrompt(agent, products, storeName) {
  const active = products.filter(p => p.active);
  const productList = active.map(formatProductForPrompt).join("\n");
  return `Você é ${agent.name}, assistente virtual da loja "${storeName}".

SEU COMPORTAMENTO POR ESTÁGIO:
1. TRIAGEM: Identifique o que o cliente precisa. Seja receptivo e pergunte o essencial.
2. VENDA: Apresente o produto certo com preço e benefícios. Conduza ao fechamento.
3. SUPORTE: Resolva problemas com empatia. Se não conseguir, oriente contato humano.

Detecte o estágio automaticamente pela intenção da mensagem.

TOM: ${agent.tone}
FOCO: ${agent.focus}

PRODUTOS DISPONÍVEIS:
${productList || "Nenhum produto ativo no momento."}

${agent.extra_instructions ? `INSTRUÇÕES ADICIONAIS:\n${agent.extra_instructions}` : ""}

REGRAS:
- Responda SEMPRE em português brasileiro
- Nunca invente preços ou produtos além dos listados
- Seja direto — máximo 3-4 linhas por mensagem
- Ao detectar intenção de compra, guie para o fechamento
- Ao detectar problema/reclamação, mude para modo suporte`;
}

// ─── Claude API (via Supabase Edge Function proxy) ───────────────────────────
const CLAUDE_PROXY = "https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/claude-proxy";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlweHR2b2R4aWR3bGpwYWh2aXlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4OTg3MjEsImV4cCI6MjA4OTQ3NDcyMX0.-n63VL73fKxf5kfxPr9xZEqBMSOMiWgfc3TtiZ_OWPk";

async function callProxy(body) {
  const res = await fetch(CLAUDE_PROXY, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify(body),
  });
  return res.json();
}

async function askClaude(systemPrompt, messages) {
  const data = await callProxy({
    model: "claude-haiku-4-5-20251001",
    max_tokens: 1000,
    system: systemPrompt,
    messages: messages.map(m => ({ role: m.role, content: m.content })),
  });
  return data.content?.map(b => b.type === "text" ? b.text : "").join("") || "Erro na resposta.";
}

async function detectStage(message) {
  const data = await callProxy({
    model: "claude-haiku-4-5-20251001",
    max_tokens: 10,
    system: `Classifique a intenção em exatamente uma palavra: TRIAGEM, VENDA ou SUPORTE.
TRIAGEM = dúvida inicial, busca de produto, interesse geral.
VENDA = quer comprar, pergunta preço, forma de pagamento, entrega.
SUPORTE = problema, reclamação, troca, atraso, defeito.
Responda APENAS com a palavra.`,
    messages: [{ role: "user", content: message }],
  });
  const raw = data.content?.[0]?.text?.trim().toUpperCase() || "TRIAGEM";
  if (raw.includes("VENDA")) return "VENDA";
  if (raw.includes("SUPORTE")) return "SUPORTE";
  return "TRIAGEM";
}

// ─── Styles ───────────────────────────────────────────────────────────────────
const S = {
  app: { display: "flex", height: "100vh", overflow: "hidden", background: "var(--bg)" },
  sidebar: { width: 220, minWidth: 220, background: "var(--bg2)", borderRight: "1px solid var(--border)", display: "flex", flexDirection: "column" },
  main: { flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" },
  sidebarLogo: { padding: "20px 20px 16px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 8 },
  logoMark: { width: 28, height: 28, background: "var(--accent)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 800, color: "#0a0b0e" },
  logoText: { fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 16, color: "var(--text)", letterSpacing: "-0.3px" },
  storeBlock: { padding: "12px 16px", margin: "12px 8px", background: "var(--bg3)", borderRadius: "var(--r)", border: "1px solid var(--border)" },
  storeName: { fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", lineHeight: 1.3 },
  storePlan: { fontSize: 11, color: "var(--accent)", fontWeight: 500, marginTop: 2 },
  nav: { flex: 1, padding: "8px 8px" },
  navItem: (a) => ({ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "9px 12px", borderRadius: "var(--r)", border: "none", background: a ? "var(--bg4)" : "transparent", color: a ? "var(--text)" : "var(--text2)", fontSize: 13, fontWeight: a ? 500 : 400, transition: "all .15s", textAlign: "left", borderLeft: `2px solid ${a ? "var(--accent)" : "transparent"}` }),
  sidebarFooter: { padding: "12px 16px", borderTop: "1px solid var(--border)" },
  waBadge: { display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "var(--text3)", marginBottom: 10 },
  btnLogout: { width: "100%", padding: "8px", background: "transparent", border: "1px solid var(--border)", borderRadius: "var(--r)", color: "var(--text2)", fontSize: 12, transition: "all .15s", fontFamily: "var(--font-body)" },
  pageHeader: { padding: "24px 28px 0", display: "flex", alignItems: "flex-start", justifyContent: "space-between" },
  pageTitle: { fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 22, color: "var(--text)", letterSpacing: "-0.5px" },
  pageSub: { fontSize: 13, color: "var(--text2)", marginTop: 3 },
  card: { background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: "var(--r2)", padding: 20 },
  section: { padding: "20px 28px", flex: 1, overflowY: "auto" },
  label: { display: "block", fontSize: 12, fontWeight: 500, color: "var(--text2)", marginBottom: 5, letterSpacing: "0.3px", textTransform: "uppercase" },
  input: { width: "100%", padding: "10px 12px", background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "var(--r)", color: "var(--text)", fontSize: 13, outline: "none" },
  select: { width: "100%", padding: "10px 12px", background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "var(--r)", color: "var(--text)", fontSize: 13, outline: "none" },
  textarea: { width: "100%", padding: "10px 12px", background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "var(--r)", color: "var(--text)", fontSize: 13, outline: "none", resize: "vertical", lineHeight: 1.6 },
  btnPrimary: { padding: "10px 20px", background: "var(--accent)", border: "none", borderRadius: "var(--r)", color: "#0a0b0e", fontSize: 13, fontWeight: 700, fontFamily: "var(--font-body)", transition: "all .15s", display: "flex", alignItems: "center", gap: 6 },
  btnSecondary: { padding: "9px 16px", background: "transparent", border: "1px solid var(--border2)", borderRadius: "var(--r)", color: "var(--text2)", fontSize: 13, transition: "all .15s", fontFamily: "var(--font-body)" },
  btnDanger: { padding: "7px 12px", background: "transparent", border: "1px solid var(--border)", borderRadius: "var(--r)", color: "var(--text3)", fontSize: 12, transition: "all .15s", fontFamily: "var(--font-body)" },
  badge: (stage) => {
    const map = { TRIAGEM: ["var(--triage)", "#2a1f0a"], VENDA: ["var(--sale)", "#131f05"], SUPORTE: ["var(--info)", "#071528"] };
    const [color, bg] = map[stage] || ["var(--text3)", "var(--bg3)"];
    return { display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600, color, background: bg };
  },
  loginBg: { minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center" },
  loginCard: { background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: "var(--r3)", padding: "44px 40px", width: "100%", maxWidth: 420, animation: "fadeUp .4s ease" },
  loginTitle: { fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 28, color: "var(--text)", letterSpacing: "-0.8px", marginBottom: 4 },
  loginSub: { fontSize: 13, color: "var(--text2)", marginBottom: 32 },
  errorBox: { padding: "10px 12px", background: "#1f0e0e", border: "1px solid #3d1515", borderRadius: "var(--r)", fontSize: 13, color: "var(--danger)", marginBottom: 8 },
};

function Spinner({ size = 16, color = "var(--accent)" }) {
  return <div style={{ width: size, height: size, border: `2px solid transparent`, borderTopColor: color, borderRadius: "50%", animation: "spin .6s linear infinite", flexShrink: 0 }} />;
}

// ─── AUTH ─────────────────────────────────────────────────────────────────────
function AuthScreen({ onAuth }) {
  const [mode, setMode] = useState("login"); // login | signup
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [storeName, setStoreName] = useState("");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    setLoading(true); setError(""); setSuccessMsg("");
    try {
      if (mode === "signup") {
        const { data, error } = await supabase.auth.signUp({
          email, password,
          options: { data: { store_name: storeName } }
        });
        if (error) throw error;
        if (data?.user) {
          setTimeout(async () => {
            await supabase.from("stores").update({
              full_name: fullName.trim(),
              phone: phone.trim(),
            }).eq("user_id", data.user.id);
          }, 2000);
        }
        setSuccessMsg("Conta criada! Verifique seu e-mail para confirmar.");
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        onAuth(data.user);
      }
    } catch (err) {
      setError(err.message || "Erro ao autenticar.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={S.loginBg}>
      <div style={S.loginCard}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <div style={{ ...S.logoMark, width: 36, height: 36, fontSize: 18 }}>V</div>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 20, color: "var(--text)" }}>VendaAI</span>
        </div>
        <div style={S.loginTitle}>{mode === "login" ? "Bem-vindo" : "Criar conta"}</div>
        <div style={S.loginSub}>{mode === "login" ? "Acesse seu painel de vendas" : "Comece grátis hoje"}</div>

        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {mode === "signup" && (
            <>
              <div>
                <label style={S.label}>Seu nome completo</label>
                <input style={S.input} value={fullName} onChange={e => setFullName(e.target.value)} placeholder="Ex: João Silva" required />
              </div>
              <div>
                <label style={S.label}>WhatsApp</label>
                <input style={S.input} type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="(51) 99999-9999" required />
              </div>
              <div>
                <label style={S.label}>Nome da loja</label>
                <input style={S.input} value={storeName} onChange={e => setStoreName(e.target.value)} placeholder="Ex: TechStore BR" required />
              </div>
            </>
          )}
          <div>
            <label style={S.label}>E-mail</label>
            <input style={S.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required />
          </div>
          <div>
            <label style={S.label}>Senha</label>
            <input style={S.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required minLength={6} />
          </div>
          {error && <div style={S.errorBox}>{error}</div>}
          {successMsg && <div style={{ ...S.errorBox, background: "#0d1f0d", border: "1px solid #1a3d1a", color: "var(--sale)" }}>{successMsg}</div>}
          <button style={{ ...S.btnPrimary, justifyContent: "center", padding: "12px", marginTop: 4 }} type="submit" disabled={loading}>
            {loading && <Spinner size={14} color="#0a0b0e" />}
            {loading ? "Aguarde…" : mode === "login" ? "Entrar" : "Criar conta"}
          </button>
        </form>

        <div style={{ marginTop: 20, textAlign: "center", fontSize: 13, color: "var(--text3)" }}>
          {mode === "login" ? "Não tem conta?" : "Já tem conta?"}{" "}
          <button onClick={() => { setMode(mode === "login" ? "signup" : "login"); setError(""); setSuccessMsg(""); }}
            style={{ background: "none", border: "none", color: "var(--accent)", fontSize: 13, cursor: "pointer", fontFamily: "var(--font-body)" }}>
            {mode === "login" ? "Criar agora" : "Entrar"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── PRODUCTS PAGE ────────────────────────────────────────────────────────────
const EMPTY_FORM = { name: "", description: "", category: "Geral", active: true, pricing_type: "unit", tiers: [{ qty: 1, price: "" }], image_url: null, audio_url: null };

function TiersEditor({ tiers, pricingType, onChange }) {
  function updateTier(i, field, val) { onChange(tiers.map((t, idx) => idx === i ? { ...t, [field]: val } : t)); }
  function addTier() { onChange([...tiers, { qty: "", price: "" }]); }
  function removeTier(i) { if (tiers.length > 1) onChange(tiers.filter((_, idx) => idx !== i)); }
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <label style={S.label}>{pricingType === "package" ? "Pacotes (qtd + preço do pacote)" : "Tabela de preços por quantidade"}</label>
        <button type="button" style={{ ...S.btnSecondary, padding: "4px 10px", fontSize: 11 }} onClick={addTier}>+ Faixa</button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {tiers.map((t, i) => (
          <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div style={{ flex: 1 }}>
              {i === 0 && <div style={{ fontSize: 10, color: "var(--text3)", marginBottom: 3 }}>{pricingType === "package" ? "QTD no pacote" : "A partir de (un)"}</div>}
              <input style={S.input} type="number" value={t.qty} onChange={e => updateTier(i, "qty", e.target.value)} placeholder={pricingType === "package" ? "Ex: 100" : "Ex: 1"} />
            </div>
            <div style={{ flex: 1 }}>
              {i === 0 && <div style={{ fontSize: 10, color: "var(--text3)", marginBottom: 3 }}>{pricingType === "package" ? "Preço do pacote (R$)" : "Preço por unidade (R$)"}</div>}
              <input style={S.input} type="number" value={t.price} onChange={e => updateTier(i, "price", e.target.value)} placeholder="0.00" />
            </div>
            <button type="button" style={{ ...S.btnDanger, color: "var(--danger)", padding: "8px 10px", marginTop: i === 0 ? 16 : 0 }} onClick={() => removeTier(i)}>×</button>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 6 }}>
        {pricingType === "package" ? "Ex: 100un = R$45, 500un = R$190" : "Ex: 1-9un = R$15/un, 10+ = R$12/un"}
      </div>
    </div>
  );
}

function ProductCard({ p, onToggle, onEdit, onDelete }) {
  const firstPrice = p.tiers?.[0]?.price;
  const lastPrice = p.tiers?.[p.tiers?.length - 1]?.price;
  const showRange = p.tiers?.length > 1;
  return (
    <div style={{ ...S.card, opacity: p.active ? 1 : 0.5, transition: "opacity .2s" }}>
      {/* Imagem do produto */}
      {p.image_url && (
        <div style={{ marginBottom: 10, borderRadius: "var(--r)", overflow: "hidden", height: 140 }}>
          <img src={p.image_url} alt={p.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
        <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)", lineHeight: 1.3, flex: 1, marginRight: 8 }}>{p.name}</div>
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          {showRange
            ? <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 13, color: "var(--accent)" }}>{fmt(lastPrice)} – {fmt(firstPrice)}</div>
            : <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 15, color: "var(--accent)" }}>{fmt(firstPrice)}</div>}
        </div>
      </div>
      {p.description && <div style={{ fontSize: 12, color: "var(--text2)", marginBottom: 8, lineHeight: 1.5 }}>{p.description}</div>}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
        {p.tiers?.map((t, i) => (
          <span key={i} style={{ fontSize: 10, color: "var(--text3)", background: "var(--bg3)", padding: "2px 7px", borderRadius: 20, border: "1px solid var(--border)" }}>
            {p.pricing_type === "package" ? `${t.qty}un = ${fmt(t.price)}` : `${t.qty}+ → ${fmt(t.price)}/un`}
          </span>
        ))}
        {p.image_url && <span style={{ fontSize: 10, color: "var(--info)", background: "#071528", padding: "2px 7px", borderRadius: 20, border: "1px solid var(--info)" }}>📷 Imagem</span>}
        {p.audio_url && <span style={{ fontSize: 10, color: "var(--sale)", background: "#131f05", padding: "2px 7px", borderRadius: 20, border: "1px solid var(--sale)" }}>🎵 Áudio</span>}
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 11, color: "var(--text3)", background: "var(--bg3)", padding: "2px 8px", borderRadius: 20, border: "1px solid var(--border)" }}>
          {p.category} · {p.pricing_type === "package" ? "Pacote" : "Unitário"}
        </span>
        <div style={{ display: "flex", gap: 6 }}>
          <button style={S.btnDanger} onClick={() => onToggle(p)}>{p.active ? "Desativar" : "Ativar"}</button>
          <button style={S.btnDanger} onClick={() => onEdit(p)}>Editar</button>
          <button style={{ ...S.btnDanger, color: "var(--danger)" }} onClick={() => onDelete(p.id)}>×</button>
        </div>
      </div>
    </div>
  );
}

function ProductsPage({ storeId }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);

  useEffect(() => { loadProducts(); }, [storeId]); // eslint-disable-line // eslint-disable-line

  async function loadProducts() {
    setLoading(true);
    const { data } = await supabase.from("products").select("*").eq("store_id", storeId).order("created_at");
    setProducts(data || []);
    setLoading(false);
  }

  function openNew() { setForm(EMPTY_FORM); setEditing(null); setShowForm(true); }
  function openEdit(p) { setForm({ ...p, tiers: p.tiers || [] }); setEditing(p.id); setShowForm(true); }

  async function uploadFile(file, type) {
    const ext = file.name.split(".").pop();
    const path = `${storeId}/${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from("products").upload(path, file, { upsert: true });
    if (error) return null;
    const { data } = supabase.storage.from("products").getPublicUrl(path);
    return data.publicUrl;
  }

  async function save() {
    if (!form.name || !form.tiers?.length) return;
    setSaving(true);
    const tiers = form.tiers.map(t => ({ qty: parseFloat(t.qty) || 0, price: parseFloat(t.price) || 0 }));
    const payload = { name: form.name, description: form.description, category: form.category, pricing_type: form.pricing_type, tiers, active: form.active, store_id: storeId, image_url: form.image_url || null, audio_url: form.audio_url || null };
    if (editing) {
      await supabase.from("products").update(payload).eq("id", editing);
    } else {
      await supabase.from("products").insert(payload);
    }
    setSaving(false);
    setShowForm(false);
    loadProducts();
  }

  async function toggle(p) {
    await supabase.from("products").update({ active: !p.active }).eq("id", p.id);
    loadProducts();
  }

  async function del(id) {
    await supabase.from("products").delete().eq("id", id);
    loadProducts();
  }

  const active = products.filter(p => p.active).length;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Catálogo</div>
          <div style={S.pageSub}>{active} produto{active !== 1 ? "s" : ""} ativo{active !== 1 ? "s" : ""} — visível{active !== 1 ? "is" : ""} para o agente</div>
        </div>
        <button style={S.btnPrimary} onClick={openNew}>+ Novo produto</button>
      </div>
      <div style={S.section}>
        {showForm && (
          <div style={{ ...S.card, marginBottom: 20, animation: "fadeUp .2s ease" }}>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15, marginBottom: 16, color: "var(--text)" }}>{editing ? "Editar produto" : "Novo produto"}</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <div style={{ gridColumn: "1/-1" }}>
                <label style={S.label}>Nome</label>
                <input style={S.input} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Ex: Bala Recheada / Smartphone Galaxy" />
              </div>
              <div>
                <label style={S.label}>Categoria</label>
                <input style={S.input} value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} placeholder="Ex: Alimentos, Celulares" />
              </div>
              <div>
                <label style={S.label}>Tipo de venda</label>
                <select style={S.select} value={form.pricing_type} onChange={e => setForm(f => ({ ...f, pricing_type: e.target.value, tiers: [{ qty: e.target.value === "package" ? 100 : 1, price: "" }] }))}>
                  <option value="unit">Unitário com escala (TV, celular...)</option>
                  <option value="package">Pacotes fechados (bala, atacado...)</option>
                </select>
              </div>
              <div style={{ gridColumn: "1/-1" }}>
                <label style={S.label}>Descrição (para o agente)</label>
                <textarea style={{ ...S.textarea, minHeight: 60 }} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Características que o agente deve mencionar" />
              </div>
              <div style={{ gridColumn: "1/-1" }}>
                <TiersEditor tiers={form.tiers} pricingType={form.pricing_type} onChange={tiers => setForm(f => ({ ...f, tiers }))} />
              </div>
              <div style={{ gridColumn: "1/-1" }}>
                <label style={S.label}>Imagem do produto (opcional)</label>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  {form.image_url ? (
                    <div style={{ position: "relative" }}>
                      <img src={form.image_url} alt="" style={{ width: 80, height: 80, objectFit: "cover", borderRadius: "var(--r)", border: "2px solid var(--accent)" }} />
                      <button style={{ position: "absolute", top: -6, right: -6, width: 18, height: 18, borderRadius: "50%", background: "var(--danger)", border: "none", color: "#fff", fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }} onClick={() => setForm(f => ({ ...f, image_url: null }))}>×</button>
                    </div>
                  ) : (
                    <label style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: "var(--bg3)", border: "1px dashed var(--border2)", borderRadius: "var(--r)", cursor: "pointer", fontSize: 13, color: "var(--text2)" }}>
                      📷 Escolher imagem
                      <input type="file" accept="image/*" style={{ display: "none" }}
                        onChange={async e => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          setSaving(true);
                          const url = await uploadFile(file, "image");
                          if (url) setForm(f => ({ ...f, image_url: url }));
                          setSaving(false);
                        }} />
                    </label>
                  )}
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>JPG, PNG ou GIF · máx 5MB</div>
                </div>
              </div>
              <div style={{ gridColumn: "1/-1" }}>
                <label style={S.label}>Áudio do produto (opcional)</label>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  {form.audio_url ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1 }}>
                      <audio controls src={form.audio_url} style={{ height: 36, flex: 1, minWidth: 200 }} />
                      <button style={{ ...S.btnDanger, color: "var(--danger)" }} onClick={() => setForm(f => ({ ...f, audio_url: null }))}>Remover</button>
                    </div>
                  ) : (
                    <label style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: "var(--bg3)", border: "1px dashed var(--border2)", borderRadius: "var(--r)", cursor: "pointer", fontSize: 13, color: "var(--text2)" }}>
                      🎵 Escolher áudio
                      <input type="file" accept="audio/*" style={{ display: "none" }}
                        onChange={async e => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          setSaving(true);
                          const url = await uploadFile(file, "audio");
                          if (url) setForm(f => ({ ...f, audio_url: url }));
                          setSaving(false);
                        }} />
                    </label>
                  )}
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>MP3, OGG ou M4A · máx 10MB</div>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <input type="checkbox" id="active" checked={form.active} onChange={e => setForm(f => ({ ...f, active: e.target.checked }))} style={{ accentColor: "var(--accent)", width: 15, height: 15 }} />
                <label htmlFor="active" style={{ fontSize: 13, color: "var(--text2)", cursor: "pointer" }}>Ativo (visível para o agente)</label>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
              <button style={S.btnPrimary} onClick={save} disabled={saving}>{saving ? <Spinner size={14} color="#0a0b0e" /> : null}{saving ? "Salvando…" : "Salvar produto"}</button>
              <button style={S.btnSecondary} onClick={() => setShowForm(false)}>Cancelar</button>
            </div>
          </div>
        )}
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><Spinner /></div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: 12 }}>
            {products.map(p => <ProductCard key={p.id} p={p} onToggle={toggle} onEdit={openEdit} onDelete={del} />)}
          </div>
        )}
        {!loading && products.length === 0 && !showForm && (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "var(--text3)" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📦</div>
            <div style={{ fontSize: 15, color: "var(--text2)", marginBottom: 6 }}>Nenhum produto cadastrado</div>
            <div style={{ fontSize: 13 }}>Adicione produtos para o agente conhecer o catálogo</div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── PLAN LIMITS ─────────────────────────────────────────────────────────────
const PLAN_LIMITS = {
  free:     { agents: 1, whatsapp: 1, label: "Free" },
  standard: { agents: 1, whatsapp: 1, label: "Standard" },
  pro:      { agents: 3, whatsapp: 3, label: "Pro" },
  business: { agents: 6, whatsapp: 6, label: "Business" },
};

function getPlanLimit(plan, key) {
  return PLAN_LIMITS[plan]?.[key] ?? PLAN_LIMITS.free[key];
}

// ─── AGENT FORM ───────────────────────────────────────────────────────────────
function AgentForm({ storeId, agent, products, onSave, onCancel }) {
  const [form, setForm] = useState(agent || { name: "", tone: "amigável e objetivo", focus: "vendas e suporte", extra_instructions: "", selected_product_ids: null });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  async function save() {
    if (!form.name) return;
    setSaving(true);
    const payload = { name: form.name, tone: form.tone, focus: form.focus, extra_instructions: form.extra_instructions, selected_product_ids: form.selected_product_ids, updated_at: new Date().toISOString() };
    if (agent?.id) {
      await supabase.from("agents").update(payload).eq("id", agent.id);
    } else {
      await supabase.from("agents").insert({ ...payload, store_id: storeId });
    }
    setSaving(false); setSaved(true);
    setTimeout(() => { setSaved(false); onSave(); }, 1000);
  }

  const activeProducts = products.filter(p => p.active);

  return (
    <div style={{ ...S.card, marginBottom: 20, animation: "fadeUp .2s ease" }}>
      <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15, marginBottom: 20, paddingBottom: 12, borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>{agent?.id ? `Editando: ${agent.name}` : "Novo agente"}</span>
        <div style={{ display: "flex", gap: 8 }}>
          <button style={{ ...S.btnPrimary, background: saved ? "var(--accent2)" : "var(--accent)" }} onClick={save} disabled={saving}>
            {saving && <Spinner size={14} color="#0a0b0e" />}
            {saved ? "✓ Salvo!" : saving ? "Salvando…" : "Salvar"}
          </button>
          <button style={S.btnSecondary} onClick={onCancel}>Cancelar</button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <div style={S.card}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Identidade</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <label style={S.label}>Nome do agente</label>
              <input style={S.input} value={form.name || ""} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Ex: Luna, Max, Sofia" />
            </div>
            <div>
              <label style={S.label}>Tom de comunicação</label>
              <select style={S.select} value={form.tone || ""} onChange={e => setForm(f => ({ ...f, tone: e.target.value }))}>
                <option>amigável e objetivo</option>
                <option>profissional e formal</option>
                <option>descontraído e jovem</option>
                <option>consultivo e especialista</option>
                <option>entusiasmado e energético</option>
              </select>
            </div>
            <div>
              <label style={S.label}>Foco principal</label>
              <select style={S.select} value={form.focus || ""} onChange={e => setForm(f => ({ ...f, focus: e.target.value }))}>
                <option>vendas e suporte</option>
                <option>somente vendas</option>
                <option>somente suporte</option>
                <option>triagem e encaminhamento</option>
              </select>
            </div>
          </div>
        </div>

        <div style={S.card}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Instruções personalizadas</div>
          <label style={S.label}>O que mais o agente deve saber?</label>
          <textarea style={{ ...S.textarea, minHeight: 140 }} value={form.extra_instructions || ""} onChange={e => setForm(f => ({ ...f, extra_instructions: e.target.value }))}
            placeholder="Exemplos:&#10;• Ofereça 5% de desconto no Pix&#10;• Prazo de entrega: 3 a 7 dias úteis&#10;• Não mencione a concorrência" />
        </div>

        <div style={{ ...S.card, gridColumn: "1/-1" }}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 12, paddingBottom: 10, borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between" }}>
            <span>Produtos deste agente</span>
            <span style={{ fontSize: 11, color: "var(--text3)", fontWeight: 400 }}>{activeProducts.length} ativos no catálogo</span>
          </div>
          {activeProducts.length === 0 ? (
            <div style={{ padding: "16px", textAlign: "center", color: "var(--text3)", fontSize: 13 }}>Nenhum produto ativo. Cadastre produtos na aba Catálogo.</div>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 8 }}>
              {activeProducts.map(p => {
                const selected = !form.selected_product_ids || form.selected_product_ids.includes(p.id);
                return (
                  <label key={p.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: selected ? "var(--bg3)" : "transparent", border: `1px solid ${selected ? "var(--border2)" : "var(--border)"}`, borderRadius: "var(--r)", cursor: "pointer" }}>
                    <input type="checkbox" checked={selected} style={{ accentColor: "var(--accent)", width: 14, height: 14, flexShrink: 0 }}
                      onChange={e => {
                        if (!form.selected_product_ids) {
                          setForm(f => ({ ...f, selected_product_ids: activeProducts.map(x => x.id).filter(id => id !== p.id) }));
                        } else {
                          setForm(f => ({ ...f, selected_product_ids: e.target.checked ? [...f.selected_product_ids, p.id] : f.selected_product_ids.filter(id => id !== p.id) }));
                        }
                      }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.name}</div>
                      <div style={{ fontSize: 11, color: "var(--accent)", fontWeight: 600 }}>{fmt(p.tiers?.[0]?.price || 0)}</div>
                    </div>
                  </label>
                );
              })}
            </div>
          )}
          <div style={{ marginTop: 10, fontSize: 12, color: "var(--text3)" }}>💡 Por padrão o agente conhece todos os produtos ativos.</div>
        </div>

        <div style={{ ...S.card, gridColumn: "1/-1" }}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 10, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Preview do sistema</div>
          <pre style={{ fontSize: 11, color: "var(--text2)", background: "var(--bg3)", padding: 14, borderRadius: "var(--r)", overflowX: "auto", lineHeight: 1.7, border: "1px solid var(--border)", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {buildSystemPrompt(form, products, "sua loja")}
          </pre>
        </div>
      </div>
    </div>
  );
}

// ─── AGENT PAGE ───────────────────────────────────────────────────────────────
function AgentPage({ storeId, plan, products }) {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null); // null = list, agent obj = editing
  const [creating, setCreating] = useState(false);

  const limit = getPlanLimit(plan, "agents");
  const atLimit = agents.length >= limit;

  useEffect(() => { loadAgents(); }, [storeId]); // eslint-disable-line // eslint-disable-line

  async function loadAgents() {
    setLoading(true);
    const { data } = await supabase.from("agents").select("*").eq("store_id", storeId).order("created_at");
    setAgents(data || []);
    setLoading(false);
  }

  async function deleteAgent(id) {
    await supabase.from("agents").delete().eq("id", id);
    loadAgents();
  }

  if (creating) return <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
    <div style={S.pageHeader}><div><div style={S.pageTitle}>Novo Agente</div></div></div>
    <div style={S.section}><AgentForm storeId={storeId} products={products} onSave={() => { setCreating(false); loadAgents(); }} onCancel={() => setCreating(false)} /></div>
  </div>;

  if (editing) return <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
    <div style={S.pageHeader}><div><div style={S.pageTitle}>Editar Agente</div></div></div>
    <div style={S.section}><AgentForm storeId={storeId} agent={editing} products={products} onSave={() => { setEditing(null); loadAgents(); }} onCancel={() => setEditing(null)} /></div>
  </div>;

  // eslint-disable-next-line no-unused-vars
  const activeProducts = products.filter(p => p.active);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Agentes</div>
          <div style={S.pageSub}>{agents.length}/{limit} agente{limit !== 1 ? "s" : ""} — plano {plan || "free"}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {atLimit && (
            <span style={{ fontSize: 12, color: "var(--warn)", background: "#2a1f0a", padding: "6px 12px", borderRadius: "var(--r)", border: "1px solid #3d2e0a" }}>
              Limite do plano atingido
            </span>
          )}
          <button style={{ ...S.btnPrimary, opacity: atLimit ? 0.5 : 1 }} onClick={() => !atLimit && setCreating(true)} disabled={atLimit}>
            + Novo agente
          </button>
        </div>
      </div>

      <div style={S.section}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><Spinner /></div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 12 }}>
            {agents.map(a => (
              <div key={a.id} style={S.card}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                  <div>
                    <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15, color: "var(--text)" }}>{a.name}</div>
                    <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 2 }}>{a.tone} · {a.focus}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button style={{ ...S.btnPrimary, padding: "6px 12px", fontSize: 12 }} onClick={() => setEditing(a)}>Editar</button>
                    {agents.length > 1 && (
                      <button style={{ ...S.btnDanger, color: "var(--danger)" }} onClick={() => deleteAgent(a.id)}>×</button>
                    )}
                  </div>
                </div>

                {a.extra_instructions && (
                  <div style={{ fontSize: 12, color: "var(--text2)", marginBottom: 8, padding: "8px 10px", background: "var(--bg3)", borderRadius: "var(--r)", border: "1px solid var(--border)", lineHeight: 1.5, maxHeight: 50, overflow: "hidden" }}>
                    {a.extra_instructions.slice(0, 100)}{a.extra_instructions.length > 100 ? "…" : ""}
                  </div>
                )}

                <WhatsAppCard agent={a} onStatusChange={loadAgents} />
              </div>
            ))}
          </div>
        )}

        {!loading && agents.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "var(--text3)" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🤖</div>
            <div style={{ fontSize: 15, color: "var(--text2)", marginBottom: 6 }}>Nenhum agente criado</div>
            <div style={{ fontSize: 13 }}>Crie um agente para começar a atender clientes</div>
          </div>
        )}

        {/* Plano info */}
        <div style={{ ...S.card, marginTop: 20, border: "1px dashed var(--border2)", background: "transparent", display: "flex", alignItems: "center", gap: 16, padding: "14px 20px" }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text)", marginBottom: 2 }}>Limites do plano {plan || "free"}</div>
            <div style={{ fontSize: 12, color: "var(--text3)" }}>
              Agentes: {agents.length}/{limit} · WhatsApp: {getPlanLimit(plan, "whatsapp")}
              {plan === "free" && " · Upgrade para Pro para ter até 3 agentes e 3 WhatsApp"}
              {plan === "pro" && " · Upgrade para Business para ter até 5 agentes e 5 WhatsApp"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── CHAT PAGE ────────────────────────────────────────────────────────────────
function ChatPage({ agent, products, storeName, storeId }) {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(agent);

  useEffect(() => {
    if (!storeId) return;
    supabase.from("agents").select("*").eq("store_id", storeId).order("created_at").then(({ data }) => {
      if (data && data.length > 0) { setAgents(data); setSelectedAgent(data[0]); }
    });
  }, [storeId]); // eslint-disable-line

  const activeAgent = selectedAgent || agent;
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState("TRIAGEM");
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  async function send() {
    const text = input.trim();
    if (!text || loading) return;
    setInput("");
    const userMsg = { role: "user", content: text };
    const newMsgs = [...messages, userMsg];
    setMessages(newMsgs);
    setLoading(true);
    try {
      const selectedProds = agent.selected_product_ids ? products.filter(p => agent.selected_product_ids.includes(p.id)) : products;
      const systemPrompt = buildSystemPrompt(agent, selectedProds, storeName);
      const [reply, newStage] = await Promise.all([askClaude(systemPrompt, newMsgs), detectStage(text)]);
      setMessages([...newMsgs, { role: "assistant", content: reply }]);
      setStage(newStage);
    } catch {
      setMessages([...newMsgs, { role: "assistant", content: "❌ Erro de conexão. Tente novamente." }]);
    } finally {
      setLoading(false);
    }
  }

  const STAGE_LABEL = { TRIAGEM: "Triagem", VENDA: "Venda", SUPORTE: "Suporte" };
  // STAGE_DOT removed

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={{ padding: "14px 20px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 12, background: "var(--bg2)" }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--bg4)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "var(--accent)" }}>{agent.name?.[0] || "A"}</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text)" }}>Testando: {agent.name}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
            <span style={S.badge(stage)}>{STAGE_LABEL[stage]}</span>
            <span style={{ fontSize: 11, color: "var(--text3)" }}>Simule mensagens do cliente para testar o agente</span>
          </div>
        </div>
        <button style={{ ...S.btnSecondary, fontSize: 12, padding: "6px 12px" }} onClick={() => { setMessages([]); setStage("TRIAGEM"); }}>🗑 Limpar</button>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "20px", display: "flex", flexDirection: "column", gap: 12 }}>
        {messages.length === 0 && (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "var(--text3)", gap: 8, paddingTop: 60 }}>
            <div style={{ fontSize: 28 }}>💬</div>
            <div style={{ fontSize: 14, color: "var(--text2)" }}>Simulador de conversa</div>
            <div style={{ fontSize: 12, textAlign: "center", maxWidth: 300 }}>Digite abaixo como se fosse um cliente e veja como o agente responde</div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start", gap: 8 }}>
            {m.role === "assistant" && (
              <div style={{ width: 28, height: 28, borderRadius: "50%", background: "var(--bg4)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "var(--accent)", flexShrink: 0, alignSelf: "flex-end" }}>{agent.name?.[0] || "A"}</div>
            )}
            <div style={{ maxWidth: "68%", padding: "10px 14px", borderRadius: m.role === "user" ? "14px 14px 4px 14px" : "14px 14px 14px 4px", background: m.role === "user" ? "var(--accent)" : "var(--bg3)", color: m.role === "user" ? "#0a0b0e" : "var(--text)", fontSize: 13, lineHeight: 1.6, border: m.role === "assistant" ? "1px solid var(--border)" : "none", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
            <div style={{ width: 28, height: 28, borderRadius: "50%", background: "var(--bg4)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "var(--accent)", flexShrink: 0 }}>{agent.name?.[0] || "A"}</div>
            <div style={{ padding: "12px 16px", background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "14px 14px 14px 4px", display: "flex", gap: 4 }}>
              {[0, 0.2, 0.4].map((d, i) => <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--text3)", animation: `pulse 1s ${d}s infinite` }} />)}
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <div style={{ padding: "12px 16px", borderTop: "1px solid var(--border)", background: "var(--bg2)", display: "flex", gap: 10, alignItems: "flex-end" }}>
        <textarea style={{ ...S.textarea, flex: 1, minHeight: 40, maxHeight: 100, resize: "none", padding: "10px 12px", lineHeight: 1.5, borderRadius: "var(--r2)" }}
          value={input} onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Simule uma mensagem do cliente… (Enter para enviar)" disabled={loading} rows={1} />
        <button style={{ ...S.btnPrimary, padding: "10px 16px", borderRadius: "var(--r2)", opacity: (!input.trim() || loading) ? 0.5 : 1, flexShrink: 0 }} onClick={send} disabled={!input.trim() || loading}>
          {loading ? <Spinner size={14} color="#0a0b0e" /> : "➤"}
        </button>
      </div>
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
function DashboardPage({ products, agent, store, onUpgrade }) {
  const active = products.filter(p => p.active).length;
  const used = store?.messages_used || 0;
  const isFree = (store?.plan || "free") === "free";
  const usagePct = isFree ? Math.min((used / 100) * 100, 100) : 0;
  const usageColor = usagePct > 80 ? "var(--danger)" : usagePct > 50 ? "var(--warn)" : "var(--sale)";

  const stats = [
    { label: "Produtos ativos", value: active, icon: "📦", color: "var(--accent)" },
    { label: "Msgs este mês", value: used, icon: "🤖", color: "var(--info)" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Dashboard</div>
          <div style={S.pageSub}>Visão geral do seu sistema</div>
        </div>
      </div>
      <div style={S.section}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 20 }}>
          {stats.map((s, i) => (
            <div key={i} style={{ ...S.card, animation: `fadeUp .3s ${i * 0.06}s both` }}>
              <div style={{ fontSize: 20, marginBottom: 8 }}>{s.icon}</div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 28, color: s.color, lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Uso do plano free */}
        {isFree && (
          <div style={{ ...S.card, marginBottom: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text)" }}>Uso do plano Free</div>
                <div style={{ fontSize: 12, color: "var(--text2)" }}>{used}/100 mensagens este mês</div>
              </div>
              <button style={{ ...S.btnPrimary, padding: "7px 16px", fontSize: 12 }} onClick={onUpgrade}>
                ⚡ Fazer upgrade
              </button>
            </div>
            <div style={{ height: 6, background: "var(--bg3)", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${usagePct}%`, background: usageColor, borderRadius: 3, transition: "width .4s ease" }} />
            </div>
            {usagePct >= 80 && (
              <div style={{ fontSize: 11, color: usageColor, marginTop: 6 }}>
                {usagePct >= 100 ? "⚠️ Limite atingido — agente pausado até o próximo mês" : "⚠️ Quase no limite — considere fazer upgrade"}
              </div>
            )}
          </div>
        )}

        {/* Pro badge */}
        {!isFree && (
          <div style={{ ...S.card, marginBottom: 16, background: "transparent", border: "1px solid var(--border2)", display: "flex", alignItems: "center", gap: 10, padding: "12px 16px" }}>
            <div style={{ fontSize: 16 }}>⚡</div>
            <div style={{ fontSize: 13, color: "var(--text2)" }}>Plano <span style={{ color: "var(--info)", fontWeight: 600 }}>Pro</span> ativo — mensagens ilimitadas</div>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div style={S.card}>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, marginBottom: 14, color: "var(--text)" }}>Agente ativo</div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
              <div style={{ width: 40, height: 40, borderRadius: "50%", background: "var(--bg4)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, color: "var(--accent)", flexShrink: 0 }}>
                {agent.name?.[0] || "A"}
              </div>
              <div>
                <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16, color: "var(--text)" }}>{agent.name || "—"}</div>
                <div style={{ fontSize: 12, color: "var(--text2)" }}>{agent.tone} · {agent.focus}</div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: agent.instance_status === "connected" ? "var(--sale)" : "var(--danger)" }} />
              <span style={{ fontSize: 12, color: "var(--text2)" }}>
                WhatsApp {agent.instance_status === "connected" ? "conectado" : "desconectado"}
              </span>
            </div>
          </div>
          <div style={S.card}>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, marginBottom: 14, color: "var(--text)" }}>Top produtos</div>
            {products.filter(p => p.active).slice(0, 4).map(p => (
              <div key={p.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
                <span style={{ fontSize: 12, color: "var(--text)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: 8 }}>{p.name}</span>
                <span style={{ fontSize: 12, color: "var(--accent)", fontWeight: 700 }}>{fmt(p.tiers?.[0]?.price || 0)}</span>
              </div>
            ))}
            {products.filter(p => p.active).length === 0 && <div style={{ fontSize: 12, color: "var(--text3)" }}>Nenhum produto ativo ainda.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}


// ─── WHATSAPP HELPERS ────────────────────────────────────────────────────────
const EVOLUTION_PROXY = "https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/evolution-proxy";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlweHR2b2R4aWR3bGpwYWh2aXlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4OTg3MjEsImV4cCI6MjA4OTQ3NDcyMX0.-n63VL73fKxf5kfxPr9xZEqBMSOMiWgfc3TtiZ_OWPk";

async function evolutionCall(path, method = "GET", body = null) {
  const res = await fetch(EVOLUTION_PROXY, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SUPABASE_ANON}` },
    body: JSON.stringify({ path, method, body }),
  });
  return res.json();
}

// ─── WHATSAPP CARD (inline no card do agente) ────────────────────────────────
function WhatsAppCard({ agent, onStatusChange }) {
  const instanceName = agent.instance_name || `vendaai-${agent.id?.slice(0, 8)}`;
  const [status, setStatus] = useState(agent.instance_status || "disconnected");
  const [qrCode, setQrCode] = useState(null);
  const [phone, setPhone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expanded] = useState(false);
  const pollRef = useRef(null);

  useEffect(() => {
    if (expanded) checkStatus();
    return () => clearInterval(pollRef.current);
  }, [expanded]); // eslint-disable-line

  async function checkStatus() {
    try {
      const data = await evolutionCall("/instance/fetchInstances");
      const instance = Array.isArray(data) ? data.find(i => i.name === instanceName) : null;
      if (instance?.connectionStatus === "open") {
        setStatus("connected");
        setPhone(instance.ownerJid?.replace("@s.whatsapp.net", ""));
        setQrCode(null);
        clearInterval(pollRef.current);
        await supabase.from("agents").update({ instance_name: instanceName, instance_status: "connected" }).eq("id", agent.id);
        onStatusChange?.();
      } else {
        setStatus("disconnected");
      }
    } catch { setStatus("disconnected"); }
  }

  async function connect() {
    setLoading(true); setQrCode(null);
    try {
      // Cria instância se não existir
      await evolutionCall("/instance/create", "POST", { instanceName, integration: "WHATSAPP-BAILEYS", qrcode: true });
      await new Promise(r => setTimeout(r, 2000));
      const data = await evolutionCall(`/instance/connect/${instanceName}`);
      if (data.base64) {
        setQrCode(data.base64);
        setStatus("connecting");
        // Salva instance_name no agente
        await supabase.from("agents").update({ instance_name: instanceName }).eq("id", agent.id);
        // Configura webhook
        await evolutionCall(`/webhook/set/${instanceName}`, "POST", {
          webhook: {
            enabled: true,
            url: "https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/whatsapp-webhook",
            headers: { "Authorization": `Bearer ${SUPABASE_ANON}` },
            events: ["MESSAGES_UPSERT"]
          }
        });
        pollRef.current = setInterval(async () => {
          const instances = await evolutionCall("/instance/fetchInstances");
          const inst = Array.isArray(instances) ? instances.find(i => i.name === instanceName) : null;
          if (inst?.connectionStatus === "open") {
            setStatus("connected");
            setPhone(inst.ownerJid?.replace("@s.whatsapp.net", ""));
            setQrCode(null);
            clearInterval(pollRef.current);
            await supabase.from("agents").update({ instance_status: "connected" }).eq("id", agent.id);
            onStatusChange?.();
          }
        }, 3000);
      }
    } catch { setStatus("disconnected"); }
    finally { setLoading(false); }
  }

  async function disconnect() {
    setLoading(true);
    await evolutionCall(`/instance/logout/${instanceName}`, "DELETE");
    setStatus("disconnected"); setPhone(null); setQrCode(null);
    await supabase.from("agents").update({ instance_status: "disconnected" }).eq("id", agent.id);
    setLoading(false);
    onStatusChange?.();
  }

  const STATUS_COLOR = { connected: "var(--sale)", connecting: "var(--warn)", disconnected: "var(--danger)", loading: "var(--text3)" };
  const STATUS_LABEL = { connected: "Conectado", connecting: "Aguardando scan...", disconnected: "Desconectado", loading: "Verificando..." };

  return (
    <div style={{ borderTop: "1px solid var(--border)", marginTop: 12, paddingTop: 12 }}>
      {/* Status row - sempre visível */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: STATUS_COLOR[status], flexShrink: 0, animation: status === "connecting" ? "pulse 1s infinite" : "none" }} />
          <span style={{ fontSize: 12, color: "var(--text2)" }}>WhatsApp — {STATUS_LABEL[status]}</span>
          {phone && <span style={{ fontSize: 11, color: "var(--text3)" }}>+{phone}</span>}
        </div>
        {/* Botão desconectar SEMPRE visível quando conectado */}
        {status === "connected" && (
          <button style={{ ...S.btnDanger, color: "var(--danger)", borderColor: "var(--danger)", fontSize: 11, padding: "4px 10px" }} onClick={disconnect} disabled={loading}>
            {loading ? <Spinner size={10} color="var(--danger)" /> : "Desconectar"}
          </button>
        )}
      </div>

      {/* Agente ativo badge quando conectado */}
      {status === "connected" && (
        <div style={{ padding: "6px 10px", background: "#0d1f0d", border: "1px solid #1a3d1a", borderRadius: "var(--r)", fontSize: 11, color: "var(--sale)" }}>
          🤖 Ativo — respondendo automaticamente 24/7
        </div>
      )}

      {/* QR Code quando conectando */}
      {qrCode && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, padding: "12px 0", animation: "fadeUp .2s ease" }}>
          <img src={qrCode} alt="QR Code" style={{ width: 160, height: 160, borderRadius: "var(--r)", border: "3px solid var(--accent)" }} />
          <div style={{ fontSize: 11, color: "var(--text2)", textAlign: "center" }}>
            WhatsApp → Dispositivos conectados → Conectar dispositivo
          </div>
          <div style={{ fontSize: 11, color: "var(--text3)", display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--warn)", animation: "pulse 1s infinite" }} />
            Expira em 60 segundos
          </div>
        </div>
      )}

      {/* Botão conectar quando desconectado */}
      {status === "disconnected" && !qrCode && (
        <button style={{ ...S.btnPrimary, width: "100%", justifyContent: "center", marginTop: 6 }} onClick={connect} disabled={loading}>
          {loading ? <Spinner size={14} color="#0a0b0e" /> : "📱 Conectar WhatsApp"}
        </button>
      )}
    </div>
  );
}


// ─── INBOX PAGE ───────────────────────────────────────────────────────────────
const STAGE_COLOR = { TRIAGEM: "var(--triage)", VENDA: "var(--sale)", SUPORTE: "var(--info)" };
const STAGE_BG = { TRIAGEM: "#2a1f0a", VENDA: "#131f05", SUPORTE: "#071528" };
const STAGE_LABEL = { TRIAGEM: "Triagem", VENDA: "Venda", SUPORTE: "Suporte" };

function timeAgo(date) {
  const diff = Date.now() - new Date(date).getTime();
  const m = Math.floor(diff / 60000);
  const h = Math.floor(diff / 3600000);
  const d = Math.floor(diff / 86400000);
  if (m < 1) return "agora";
  if (m < 60) return `${m}min`;
  if (h < 24) return `${h}h`;
  return `${d}d`;
}

function InboxPage({ storeId, initialConvId, onConvOpened }) {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeConv, setActiveConv] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loadingMsgs, setLoadingMsgs] = useState(false);
  const [filter, setFilter] = useState("all");
  const [agents, setAgents] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState("all");
  const bottomRef = useRef(null);

  useEffect(() => {
    supabase.from("agents").select("*").eq("store_id", storeId).order("created_at").then(({ data }) => {
      if (data) setAgents(data);
    });
  }, [storeId]); // eslint-disable-line

  useEffect(() => { // eslint-disable-line
    loadConversations();
    // Realtime subscription
    const sub = supabase
      .channel("conversations") // eslint-disable-line
      .on("postgres_changes", { event: "*", schema: "public", table: "conversations", filter: `store_id=eq.${storeId}` }, () => loadConversations())
      .on("postgres_changes", { event: "INSERT", schema: "public", table: "messages" }, (payload) => {
        if (activeConv && payload.new.conversation_id === activeConv.id) {
          setMessages(prev => [...prev, payload.new]);
        }
      })
      .subscribe();
    return () => supabase.removeChannel(sub);
  }, [storeId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  async function loadConversations() {
    const { data } = await supabase
      .from("conversations")
      .select("*")
      .eq("store_id", storeId)
      .order("last_message_at", { ascending: false });
    setConversations(data || []);
    setLoading(false);
  }

  useEffect(() => {
    if (!initialConvId) return;
    const tryOpen = (convs) => {
      const conv = convs.find(c => c.id === initialConvId);
      if (conv) { openConversation(conv); onConvOpened?.(); return true; }
      return false;
    };
    if (conversations.length > 0) {
      if (!tryOpen(conversations)) {
        supabase.from("conversations").select("*").eq("id", initialConvId).single()
          .then(({ data }) => { if (data) { openConversation(data); onConvOpened?.(); } });
      }
    } else {
      supabase.from("conversations").select("*").eq("id", initialConvId).single()
        .then(({ data }) => { if (data) { openConversation(data); onConvOpened?.(); } });
    }
  }, [initialConvId]); // eslint-disable-line

  async function openConversation(conv) {
    setActiveConv(conv);
    setLoadingMsgs(true);
    const { data } = await supabase
      .from("messages")
      .select("*")
      .eq("conversation_id", conv.id)
      .order("created_at", { ascending: true });
    setMessages(data || []);
    setLoadingMsgs(false);
    // Marca como lido
    await supabase.from("conversations").update({ unread_count: 0 }).eq("id", conv.id);
    setConversations(prev => prev.map(c => c.id === conv.id ? { ...c, unread_count: 0 } : c));
  }

  async function resolveConv(id) {
    await supabase.from("conversations").update({ status: "resolved" }).eq("id", id);
    loadConversations();
    if (activeConv?.id === id) setActiveConv(prev => ({ ...prev, status: "resolved" }));
  }

  const filtered = conversations.filter(c => {
    if (selectedAgentId !== "all" && c.agent_id !== selectedAgentId) return false;
    if (filter === "open") return c.status === "open";
    if (filter === "resolved") return c.status === "resolved";
    if (filter === "TRIAGEM" || filter === "VENDA" || filter === "SUPORTE") return c.stage === filter;
    return true;
  });

  const totalUnread = conversations.reduce((acc, c) => acc + (c.unread_count || 0), 0);

  return (
    <div style={{ display: "flex", height: "100%", overflow: "hidden" }}>
      {/* Lista de conversas */}
      <div style={{ width: 280, minWidth: 280, borderRight: "1px solid var(--border)", display: "flex", flexDirection: "column", background: "var(--bg2)" }}>
        <div style={{ padding: "14px 16px 10px", borderBottom: "1px solid var(--border)" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
            <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)" }}>
              Conversas {totalUnread > 0 && <span style={{ background: "var(--accent)", color: "#0a0b0e", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 20, marginLeft: 4 }}>{totalUnread}</span>}
            </span>
            <button style={{ ...S.btnSecondary, padding: "4px 8px", fontSize: 11 }} onClick={loadConversations}>↻</button>
          </div>
          {/* Seletor de agente */}
          {agents.length > 1 && (
            <select style={{ ...S.select, fontSize: 11, marginBottom: 8, width: "100%" }}
              value={selectedAgentId} onChange={e => setSelectedAgentId(e.target.value)}>
              <option value="all">Todos os agentes</option>
              {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          )}
          {/* Filtros */}
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {["all", "open", "TRIAGEM", "VENDA", "SUPORTE", "resolved"].map(f => (
              <button key={f} onClick={() => setFilter(f)}
                style={{ padding: "3px 8px", borderRadius: 20, fontSize: 10, fontWeight: 500, cursor: "pointer", border: "1px solid", transition: "all .15s", fontFamily: "var(--font-body)",
                  background: filter === f ? "var(--accent)" : "transparent",
                  color: filter === f ? "#0a0b0e" : "var(--text3)",
                  borderColor: filter === f ? "var(--accent)" : "var(--border)" }}>
                {f === "all" ? "Todas" : f === "open" ? "Abertas" : f === "resolved" ? "Resolvidas" : STAGE_LABEL[f]}
              </button>
            ))}
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 30 }}><Spinner /></div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 20px", color: "var(--text3)" }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>💬</div>
              <div style={{ fontSize: 13 }}>Nenhuma conversa ainda</div>
            </div>
          ) : (
            filtered.map(c => (
              <div key={c.id} onClick={() => openConversation(c)}
                style={{ padding: "12px 14px", cursor: "pointer", background: activeConv?.id === c.id ? "var(--bg4)" : "transparent", borderLeft: `2px solid ${activeConv?.id === c.id ? "var(--accent)" : "transparent"}`, transition: "all .1s", borderBottom: "1px solid var(--border)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                  <span style={{ fontSize: 13, fontWeight: 500, color: "var(--text)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: 6 }}>
                    {c.client_name || c.client_phone}
                  </span>
                  <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                    {c.unread_count > 0 && <span style={{ background: "var(--accent)", color: "#0a0b0e", fontSize: 9, fontWeight: 700, padding: "1px 5px", borderRadius: 20 }}>{c.unread_count}</span>}
                    <span style={{ fontSize: 10, color: "var(--text3)" }}>{timeAgo(c.last_message_at)}</span>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 6px", borderRadius: 20, background: STAGE_BG[c.stage], color: STAGE_COLOR[c.stage] }}>{STAGE_LABEL[c.stage]}</span>
                  <span style={{ fontSize: 10, color: c.status === "resolved" ? "var(--text3)" : "var(--sale)" }}>
                    {c.status === "resolved" ? "Resolvida" : "Aberta"}
                  </span>
                  <span style={{ fontSize: 10, color: "var(--text3)" }}>{c.client_phone}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Área da conversa */}
      {activeConv ? (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          {/* Header */}
          <div style={{ padding: "12px 20px", borderBottom: "1px solid var(--border)", background: "var(--bg2)", display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--bg4)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "var(--text2)", flexShrink: 0 }}>
              {(activeConv.client_name || activeConv.client_phone)?.[0]?.toUpperCase()}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text)" }}>{activeConv.client_name || activeConv.client_phone}</div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
                <span style={{ fontSize: 11, padding: "2px 7px", borderRadius: 20, background: STAGE_BG[activeConv.stage], color: STAGE_COLOR[activeConv.stage], fontWeight: 600 }}>{STAGE_LABEL[activeConv.stage]}</span>
                <span style={{ fontSize: 11, color: "var(--text3)" }}>{activeConv.client_phone}</span>
              </div>
            </div>
            {activeConv.status === "open" && (
              <button style={{ ...S.btnSecondary, fontSize: 12, padding: "6px 12px" }} onClick={() => resolveConv(activeConv.id)}>
                ✓ Resolver
              </button>
            )}
            {activeConv.status === "resolved" && (
              <span style={{ fontSize: 11, color: "var(--text3)", background: "var(--bg3)", padding: "4px 10px", borderRadius: 20, border: "1px solid var(--border)" }}>Resolvida</span>
            )}
          </div>

          {/* Mensagens */}
          <div style={{ flex: 1, overflowY: "auto", padding: "20px", display: "flex", flexDirection: "column", gap: 10 }}>
            {loadingMsgs ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><Spinner /></div>
            ) : messages.length === 0 ? (
              <div style={{ textAlign: "center", color: "var(--text3)", paddingTop: 40 }}>Nenhuma mensagem nesta conversa</div>
            ) : (
              messages.map((m, i) => (
                <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-start" : "flex-end" }}>
                  <div style={{
                    maxWidth: "70%", padding: "9px 13px",
                    borderRadius: m.role === "user" ? "14px 14px 14px 4px" : "14px 14px 4px 14px",
                    background: m.role === "user" ? "var(--bg3)" : "var(--accent)",
                    color: m.role === "user" ? "var(--text)" : "#0a0b0e",
                    fontSize: 13, lineHeight: 1.6,
                    border: m.role === "user" ? "1px solid var(--border)" : "none",
                    whiteSpace: "pre-wrap", wordBreak: "break-word",
                  }}>
                    {m.content}
                  </div>
                </div>
              ))
            )}
            <div ref={bottomRef} />
          </div>

          {/* Footer info */}
          <div style={{ padding: "10px 20px", borderTop: "1px solid var(--border)", background: "var(--bg2)", display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--sale)", animation: "pulse 2s infinite" }} />
            <span style={{ fontSize: 12, color: "var(--text3)" }}>Agente respondendo automaticamente via WhatsApp</span>
          </div>
        </div>
      ) : (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "var(--text3)", gap: 8 }}>
          <div style={{ fontSize: 32 }}>💬</div>
          <div style={{ fontSize: 14, color: "var(--text2)" }}>Selecione uma conversa</div>
          <div style={{ fontSize: 12 }}>Acompanhe em tempo real as conversas do WhatsApp</div>
        </div>
      )}
    </div>
  );
}


// ─── TOUR GUIADO ─────────────────────────────────────────────────────────────
const TOUR_STEPS = [
  {
    target: "nav-dashboard",
    title: "Dashboard",
    desc: "Visão geral da sua conta — produtos ativos, agente configurado e status do WhatsApp.",
    position: "right",
  },
  {
    target: "nav-inbox",
    title: "Conversas",
    desc: "Acompanhe em tempo real todas as conversas do WhatsApp. Veja o estágio de cada cliente: Triagem, Venda ou Suporte.",
    position: "right",
  },
  {
    target: "nav-chat",
    title: "Testar Agente",
    desc: "Simule uma conversa como se fosse um cliente. Teste o agente antes de conectar o WhatsApp.",
    position: "right",
  },
  {
    target: "nav-products",
    title: "Catálogo",
    desc: "Cadastre seus produtos com preços e descrições. O agente usa essas informações para responder clientes.",
    position: "right",
  },
  {
    target: "nav-agent",
    title: "Agentes",
    desc: "Configure o nome, tom e instruções do seu agente. Aqui você também conecta o WhatsApp.",
    position: "right",
  },
];

function TourGuide({ onFinish }) {
  const [step, setStep] = useState(0);
  const [targetRect, setTargetRect] = useState(null);
  const current = TOUR_STEPS[step];

  useEffect(() => {
    const el = document.getElementById(current.target);
    if (el) {
      const rect = el.getBoundingClientRect();
      setTargetRect(rect);
      el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [step, current.target]);

  function next() {
    if (step < TOUR_STEPS.length - 1) setStep(s => s + 1);
    else onFinish();
  }

  if (!targetRect) return null;

  const TOOLTIP_W = 280;
  const TOOLTIP_H = 140;
  const GAP = 12;

  // Position tooltip to the right of the target
  const tooltipLeft = targetRect.right + GAP;
  const tooltipTop = targetRect.top + (targetRect.height / 2) - (TOOLTIP_H / 2);

  return (
    <>
      {/* Overlay com buraco no target */}
      <div style={{ position: "fixed", inset: 0, zIndex: 9998, pointerEvents: "none" }}>
        {/* Top */}
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: Math.max(0, targetRect.top - 4), background: "rgba(0,0,0,0.7)" }} />
        {/* Bottom */}
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, top: targetRect.bottom + 4, background: "rgba(0,0,0,0.7)" }} />
        {/* Left */}
        <div style={{ position: "absolute", top: targetRect.top - 4, left: 0, width: Math.max(0, targetRect.left - 4), height: targetRect.height + 8, background: "rgba(0,0,0,0.7)" }} />
        {/* Right of target (only if tooltip is not there) */}
        <div style={{ position: "absolute", top: targetRect.top - 4, left: targetRect.right + 4, right: 0, height: targetRect.height + 8, background: "rgba(0,0,0,0.7)" }} />
        {/* Highlight border */}
        <div style={{ position: "absolute", top: targetRect.top - 4, left: targetRect.left - 4, width: targetRect.width + 8, height: targetRect.height + 8, border: "2px solid var(--accent)", borderRadius: 10, boxShadow: "0 0 0 4px rgba(184,249,78,0.15)" }} />
      </div>

      {/* Clickable overlay to close */}
      <div style={{ position: "fixed", inset: 0, zIndex: 9997 }} onClick={onFinish} />

      {/* Tooltip */}
      <div style={{
        position: "fixed", zIndex: 9999,
        left: Math.min(tooltipLeft, window.innerWidth - TOOLTIP_W - 16),
        top: Math.max(8, Math.min(tooltipTop, window.innerHeight - TOOLTIP_H - 8)),
        width: TOOLTIP_W,
        background: "var(--bg2)", border: "1px solid var(--accent)",
        borderRadius: "var(--r2)", padding: "16px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
        animation: "fadeUp .2s ease",
        pointerEvents: "all",
      }}>
        {/* Arrow */}
        <div style={{ position: "absolute", left: -8, top: "50%", transform: "translateY(-50%)", width: 0, height: 0, borderTop: "8px solid transparent", borderBottom: "8px solid transparent", borderRight: "8px solid var(--accent)" }} />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--accent)" }}>{current.title}</div>
          <span style={{ fontSize: 11, color: "var(--text3)" }}>{step + 1}/{TOUR_STEPS.length}</span>
        </div>
        <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6, marginBottom: 14 }}>{current.desc}</div>

        {/* Progress dots */}
        <div style={{ display: "flex", gap: 5, marginBottom: 12 }}>
          {TOUR_STEPS.map((_, i) => (
            <div key={i} style={{ width: i === step ? 16 : 6, height: 6, borderRadius: 3, background: i === step ? "var(--accent)" : "var(--border2)", transition: "all .2s" }} />
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button style={{ background: "none", border: "none", fontSize: 12, color: "var(--text3)", cursor: "pointer", fontFamily: "var(--font-body)", padding: 0 }} onClick={onFinish}>
            Pular tour
          </button>
          <button style={{ ...S.btnPrimary, padding: "7px 16px", fontSize: 12 }} onClick={next}>
            {step < TOUR_STEPS.length - 1 ? "Próximo →" : "Concluir ✓"}
          </button>
        </div>
      </div>
    </>
  );
}



// ─── ADMIN PAGE ───────────────────────────────────────────────────────────────
function AdminPage() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => { loadStores(); }, []); // eslint-disable-line

  async function loadStores() {
    setLoading(true);
    const { data } = await supabase
      .from("admin_stores_view")
      .select("*")
      .order("created_at", { ascending: false });
    setStores(data || []);
    setLoading(false);
  }

  async function changePlan(storeId, plan) {
    setUpdating(storeId);
    await fetch("https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/admin-update-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SUPABASE_ANON_KEY}` },
      body: JSON.stringify({ store_id: storeId, plan }),
    });
    await loadStores();
    setUpdating(null);
  }

  const filtered = stores.filter(s =>
    s.name?.toLowerCase().includes(search.toLowerCase()) ||
    s.email?.toLowerCase().includes(search.toLowerCase())
  );

  const totalConversations = stores.reduce((a, s) => a + (s.conversations_count || 0), 0);
  const totalRevenue = stores.reduce((a, s) => a + Number(s.total_revenue || 0), 0);
  const totalPaidOrders = stores.reduce((a, s) => a + Number(s.paid_orders || 0), 0);
  const totalMessages = stores.reduce((a, s) => a + (s.messages_sent || 0), 0);
  const totalConnected = stores.reduce((a, s) => a + (s.whatsapp_connected || 0), 0);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={{ ...S.pageTitle, color: "var(--warn)" }}>⚡ Admin</div>
          <div style={S.pageSub}>Visão geral de todos os lojistas</div>
        </div>
        <button style={{ ...S.btnSecondary, fontSize: 12 }} onClick={loadStores}>↻ Atualizar</button>
      </div>

      <div style={S.section}>
        {/* Stats gerais */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Lojistas", value: stores.length, icon: "🏪", color: "var(--accent)" },
            { label: "WhatsApp ativos", value: totalConnected, icon: "📱", color: "var(--sale)" },
            { label: "Receita total", value: fmt(totalRevenue), icon: "💰", color: "var(--accent)" },
            { label: "Pedidos pagos", value: totalPaidOrders, icon: "✅", color: "var(--info)" },
            { label: "Conversas total", value: totalConversations, icon: "💬", color: "var(--info)" },
            { label: "Msgs enviadas", value: totalMessages, icon: "🤖", color: "var(--warn)" },
          ].map((s, i) => (
            <div key={i} style={{ ...S.card, animation: `fadeUp .2s ${i * 0.05}s both` }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>{s.icon}</div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 24, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 11, color: "var(--text2)", marginTop: 3 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Busca */}
        <input style={{ ...S.input, marginBottom: 14, maxWidth: 360 }} value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar por nome ou e-mail..." />

        {/* Tabela de lojistas */}
        <div style={{ ...S.card, padding: 0, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 110px 70px 70px 70px 90px 90px 130px", padding: "10px 16px", borderBottom: "1px solid var(--border)", background: "var(--bg3)" }}>
            {["Lojista", "Plano", "Agentes", "Conversas", "Msgs IA", "Receita", "Pedidos", "Ação"].map(h => (
              <div key={h} style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.5px" }}>{h}</div>
            ))}
          </div>

          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><Spinner /></div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", color: "var(--text3)", fontSize: 13 }}>Nenhum lojista encontrado</div>
          ) : (
            filtered.map(s => (
              <div key={s.id} style={{ display: "grid", gridTemplateColumns: "1fr 110px 70px 70px 70px 90px 90px 130px", padding: "12px 16px", borderBottom: "1px solid var(--border)", alignItems: "center", transition: "background .1s" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text)" }}>{s.name}</div>
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>{s.email}</div>
                  <div style={{ fontSize: 10, color: "var(--text3)", marginTop: 2 }}>
                    {s.onboarding_completed ? "✓ onboarding" : "⏳ sem onboarding"} · {new Date(s.created_at).toLocaleDateString("pt-BR")}
                  </div>
                </div>
                <div>
                  <span style={{
                    fontSize: 11, fontWeight: 600, padding: "3px 8px", borderRadius: 20,
                    background: s.plan === "business" ? "#1f1205" : s.plan === "pro" ? "#071528" : "var(--bg3)",
                    color: s.plan === "business" ? "var(--warn)" : s.plan === "pro" ? "var(--info)" : "var(--text3)",
                    border: `1px solid ${s.plan === "business" ? "var(--warn)" : s.plan === "pro" ? "var(--info)" : "var(--border)"}`,
                  }}>{s.plan || "free"}</span>
                </div>
                <div style={{ fontSize: 13, color: "var(--text2)", textAlign: "center" }}>{s.agents_count || 0}</div>
                <div style={{ fontSize: 13, color: "var(--text2)", textAlign: "center" }}>{s.conversations_count || 0}</div>
                <div style={{ fontSize: 13, color: "var(--sale)", textAlign: "center", fontWeight: 600 }}>{s.messages_sent || 0}</div>
                <div style={{ fontSize: 13, color: "var(--accent)", textAlign: "center", fontWeight: 700 }}>{fmt(s.total_revenue || 0)}</div>
                <div style={{ fontSize: 13, color: "var(--info)", textAlign: "center", fontWeight: 600 }}>{s.paid_orders || 0}</div>
                <div>
                  <select
                    style={{ ...S.select, fontSize: 11, padding: "4px 8px", opacity: updating === s.id ? 0.5 : 1 }}
                    value={s.plan || "free"}
                    onChange={e => changePlan(s.id, e.target.value)}
                    disabled={updating === s.id}
                  >
                    <option value="free">Free</option>
                    <option value="standard">Standard</option>
                    <option value="pro">Pro</option>
                    <option value="business">Business</option>
                  </select>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}


// ─── UPGRADE MODAL ────────────────────────────────────────────────────────────
function UpgradeModal({ store, user, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function subscribe() {
    setLoading(true); setError("");
    try {
      const res = await fetch("https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/create-subscription", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SUPABASE_ANON_KEY}` },
        body: JSON.stringify({ store_id: store.id, plan: "standard", payer_email: user.email }),
      });
      const data = await res.json();
      if (data.init_point) {
        window.open(data.init_point, "_blank");
        onClose();
      } else {
        setError("Erro ao criar assinatura. Tente novamente.");
      }
    } catch {
      setError("Erro de conexão. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ ...S.card, maxWidth: 480, width: "100%", animation: "fadeUp .2s ease" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 22, color: "var(--text)", marginBottom: 4 }}>Fazer upgrade ⚡</div>
            <div style={{ fontSize: 13, color: "var(--text2)" }}>Mais mensagens, mesmo número e agente</div>
          </div>
          <button style={{ background: "none", border: "none", color: "var(--text3)", fontSize: 20, cursor: "pointer", padding: 0 }} onClick={onClose}>×</button>
        </div>

        {/* Free — atual */}
        <div style={{ padding: "12px 14px", background: "var(--bg3)", borderRadius: "var(--r)", border: "1px solid var(--border)", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center", opacity: 0.6 }}>
          <div>
            <div style={{ fontSize: 12, color: "var(--text3)", fontWeight: 600, marginBottom: 3 }}>FREE — ATUAL</div>
            <div style={{ fontSize: 11, color: "var(--text3)" }}>1 agente · 1 WhatsApp · 100 msgs/mês</div>
          </div>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 15, color: "var(--text3)" }}>Grátis</div>
        </div>

        {/* Standard — disponível */}
        <div style={{ padding: "14px", background: "var(--bg4)", borderRadius: "var(--r)", border: "2px solid var(--info)", marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "var(--info)" }}>STANDARD</div>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 18, color: "var(--info)" }}>R$47/mês</div>
          </div>
          <div style={{ fontSize: 12, color: "var(--text2)", marginBottom: 4 }}>✓ 1 agente · 1 WhatsApp</div>
          <div style={{ fontSize: 12, color: "var(--text2)" }}>✓ 1.000 msgs/mês — 10x mais que o Free</div>
        </div>

        {/* Pro e Business — em breve */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16, opacity: 0.4 }}>
          {[
            { label: "PRO", price: "R$97/mês", features: "3 agentes · 3 WhatsApp · 3.000 msgs" },
            { label: "BUSINESS", price: "R$197/mês", features: "6 agentes · 6 WhatsApp · 8.000 msgs" },
          ].map(p => (
            <div key={p.label} style={{ padding: "10px 12px", background: "var(--bg3)", borderRadius: "var(--r)", border: "1px solid var(--border)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)" }}>{p.label}</span>
                <span style={{ fontSize: 9, color: "var(--text3)", background: "var(--bg4)", padding: "1px 6px", borderRadius: 20 }}>EM BREVE</span>
              </div>
              <div style={{ fontSize: 10, color: "var(--text3)", marginBottom: 4 }}>{p.features}</div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text3)" }}>{p.price}</div>
            </div>
          ))}
        </div>

        {error && <div style={{ ...S.errorBox, marginBottom: 12 }}>{error}</div>}

        <button style={{ ...S.btnPrimary, width: "100%", justifyContent: "center", padding: "13px", fontSize: 14 }} onClick={subscribe} disabled={loading}>
          {loading ? <Spinner size={16} color="#0a0b0e" /> : "Assinar Standard — R$47/mês"}
        </button>
        <div style={{ fontSize: 11, color: "var(--text3)", textAlign: "center", marginTop: 10 }}>
          Cancele a qualquer momento · Cobrado via Mercado Pago
        </div>
        <div style={{ fontSize: 11, color: "var(--warn)", textAlign: "center", marginTop: 6, padding: "6px 10px", background: "#2a1f0a", borderRadius: "var(--r)", border: "1px solid #3d2e0a" }}>
          ⚠️ Use o mesmo e-mail da sua conta VendaAI para pagar e garantir a ativação automática.
        </div>
      </div>
    </div>
  );
}


// ─── EDITABLE STORE NAME ─────────────────────────────────────────────────────
function EditableStoreName({ store, onUpdate }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(store?.name || "");
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!name.trim()) return;
    setSaving(true);
    await supabase.from("stores").update({ name: name.trim() }).eq("id", store.id);
    onUpdate(name.trim());
    setSaving(false);
    setEditing(false);
  }

  if (editing) {
    return (
      <div style={{ padding: "8px 8px", display: "flex", flexDirection: "column", gap: 6 }}>
        <input
          style={{ ...S.input, fontSize: 12, padding: "7px 10px" }}
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
          autoFocus
        />
        <div style={{ display: "flex", gap: 6 }}>
          <button style={{ ...S.btnPrimary, flex: 1, justifyContent: "center", padding: "6px", fontSize: 11 }} onClick={save} disabled={saving}>
            {saving ? <Spinner size={10} color="#0a0b0e" /> : "Salvar"}
          </button>
          <button style={{ ...S.btnSecondary, padding: "6px 10px", fontSize: 11 }} onClick={() => setEditing(false)}>✕</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ ...S.storeBlock, cursor: "pointer", position: "relative", group: true }}
      onClick={() => { setName(store?.name || ""); setEditing(true); }}
      title="Clique para editar o nome da loja">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={S.storeName}>{store?.name || "Minha Loja"}</div>
        <span style={{ fontSize: 10, color: "var(--text3)", opacity: 0.6 }}>✎</span>
      </div>
      <div style={S.storePlan}>Plano {store?.plan || "free"}</div>
    </div>
  );
}


// ─── INTEGRATIONS PAGE ───────────────────────────────────────────────────────
function IntegrationsPage({ store, onUpdate }) {
  const [mpToken, setMpToken] = useState(store?.mp_access_token ? "••••••••••••••••" : "");
  const [mpInput, setMpInput] = useState("");
  const [editingMp, setEditingMp] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const mpConnected = !!store?.mp_access_token;

  async function saveMpToken() {
    if (!mpInput.trim()) return;
    setSaving(true);
    await fetch("https://ypxtvodxidwljpahviyr.supabase.co/functions/v1/admin-update-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SUPABASE_ANON_KEY}` },
      body: JSON.stringify({ store_id: store.id, plan: store.plan }),
    });
    // Salva o token MP diretamente
    await supabase.from("stores").update({ mp_access_token: mpInput.trim() }).eq("id", store.id);
    setSaving(false);
    setSaved(true);
    setEditingMp(false);
    setMpToken("••••••••••••••••");
    onUpdate?.();
    setTimeout(() => setSaved(false), 2000);
  }

  async function removeMpToken() {
    await supabase.from("stores").update({ mp_access_token: null }).eq("id", store.id);
    setMpToken("");
    setMpInput("");
    onUpdate?.();
  }

  const integrations = [
    {
      id: "mp",
      icon: "💳",
      name: "Mercado Pago",
      desc: "Receba pagamentos via Pix automaticamente no WhatsApp. O agente gera o QR Code e confirma o pagamento.",
      connected: mpConnected,
      available: true,
      features: ["QR Code Pix automático", "Confirmação automática", "Dashboard de pedidos"],
    },
    {
      id: "shopify",
      icon: "🛍️",
      name: "Shopify",
      desc: "Sincronize seu catálogo automaticamente. O agente consulta produtos, preços e estoque em tempo real.",
      connected: false,
      available: false,
      features: ["Catálogo automático", "Estoque em tempo real", "Link de checkout"],
    },
    {
      id: "vista",
      icon: "🏠",
      name: "Vista CRM",
      desc: "Integre seus imóveis automaticamente. O agente qualifica leads e agenda visitas.",
      connected: false,
      available: false,
      features: ["Imóveis automáticos", "Qualificação de leads", "Agendamento de visitas"],
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Integrações</div>
          <div style={S.pageSub}>Conecte suas ferramentas ao VendaAI</div>
        </div>
      </div>
      <div style={S.section}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 700 }}>
          {integrations.map(intg => (
            <div key={intg.id} style={{ ...S.card, opacity: intg.available ? 1 : 0.6 }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
                <div style={{ fontSize: 28, flexShrink: 0 }}>{intg.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                    <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16, color: "var(--text)" }}>{intg.name}</div>
                    {intg.connected && (
                      <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 20, background: "#0d1f0d", color: "var(--sale)", border: "1px solid var(--sale)" }}>● Conectado</span>
                    )}
                    {!intg.available && (
                      <span style={{ fontSize: 10, color: "var(--text3)", background: "var(--bg3)", padding: "2px 8px", borderRadius: 20, border: "1px solid var(--border)" }}>Em breve</span>
                    )}
                  </div>
                  <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 10, lineHeight: 1.5 }}>{intg.desc}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
                    {intg.features.map(f => (
                      <span key={f} style={{ fontSize: 11, color: "var(--text3)", background: "var(--bg3)", padding: "3px 8px", borderRadius: 20, border: "1px solid var(--border)" }}>✓ {f}</span>
                    ))}
                  </div>

                  {/* Mercado Pago config */}
                  {intg.id === "mp" && intg.available && (
                    <div>
                      {!editingMp && !mpConnected && (
                        <button style={{ ...S.btnPrimary, padding: "8px 16px", fontSize: 12 }} onClick={() => setEditingMp(true)}>
                          Conectar Mercado Pago
                        </button>
                      )}
                      {!editingMp && mpConnected && (
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                          <div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "monospace", background: "var(--bg3)", padding: "6px 12px", borderRadius: "var(--r)", border: "1px solid var(--border)" }}>
                            {mpToken}
                          </div>
                          <button style={{ ...S.btnSecondary, fontSize: 11, padding: "6px 12px" }} onClick={() => setEditingMp(true)}>Trocar</button>
                          <button style={{ ...S.btnDanger, color: "var(--danger)", fontSize: 11 }} onClick={removeMpToken}>Remover</button>
                        </div>
                      )}
                      {editingMp && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          <div style={{ fontSize: 12, color: "var(--text2)", marginBottom: 4 }}>
                            Cole o <strong>Access Token</strong> de produção da sua conta Mercado Pago.{" "}
                            <a href="https://www.mercadopago.com.br/developers/panel/app" target="_blank" rel="noreferrer" style={{ color: "var(--accent)" }}>Obter token →</a>
                          </div>

                          <input
                            style={{ ...S.input, fontFamily: "monospace", fontSize: 12 }}
                            value={mpInput}
                            onChange={e => setMpInput(e.target.value)}
                            placeholder="APP_USR-..."
                            type="password"
                          />
                          <div style={{ fontSize: 11, color: "var(--warn)", padding: "6px 10px", background: "#2a1f0a", borderRadius: "var(--r)", border: "1px solid #3d2e0a" }}>
                            ⚠️ O token fica salvo de forma segura. O dinheiro vai direto para sua conta MP.
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button style={{ ...S.btnPrimary, padding: "8px 16px", fontSize: 12 }} onClick={saveMpToken} disabled={saving || !mpInput.trim()}>
                              {saving ? <Spinner size={12} color="#0a0b0e" /> : saved ? "✓ Salvo!" : "Salvar token"}
                            </button>
                            <button style={{ ...S.btnSecondary, fontSize: 12 }} onClick={() => { setEditingMp(false); setMpInput(""); }}>Cancelar</button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Instrucoes MP */}
        {!mpConnected && (
          <div style={{ ...S.card, marginTop: 20, maxWidth: 700, background: "transparent", border: "1px dashed var(--border2)" }}>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 12 }}>Como conectar o Mercado Pago</div>
            {[
              "Acesse mercadopago.com.br/developers e faça login",
              "Clique em 'Suas integrações' → 'Criar aplicação'",
              "Escolha 'Pagamentos online' → 'Checkout Transparente' → 'API de Pagamentos'",
              "Vá em 'Credenciais de produção' e copie o Access Token",
              "Cole o token acima e clique em Salvar",
              "Configure o webhook na sua app MP: URL fornecida pelo suporte VendaAI, evento = Pagamentos",
            ].map((step, i) => (
              <div key={i} style={{ display: "flex", gap: 10, marginBottom: 8, alignItems: "flex-start" }}>
                <div style={{ width: 20, height: 20, borderRadius: "50%", background: "var(--accent)", color: "#0a0b0e", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>{i + 1}</div>
                <div style={{ fontSize: 12, color: "var(--text2)", lineHeight: 1.5 }}>{step}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}


// ─── ORDERS PAGE ──────────────────────────────────────────────────────────────
const ORDER_STATUS = {
  pending:   { label: "Aguardando",  color: "var(--warn)",   bg: "#2a1f0a" },
  paid:      { label: "Pago",        color: "var(--sale)",   bg: "#0d1f0d" },
  cancelled: { label: "Cancelado",   color: "var(--danger)", bg: "#1f0a0a" },
  rejected:  { label: "Rejeitado",   color: "var(--danger)", bg: "#1f0a0a" },
};

function OrdersPage({ storeId, onOpenConversation }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    loadOrders();
    // Realtime
    const sub = supabase
      .channel("orders")
      .on("postgres_changes", { event: "*", schema: "public", table: "orders", filter: `store_id=eq.${storeId}` }, () => loadOrders())
      .subscribe();
    return () => supabase.removeChannel(sub);
  }, [storeId]); // eslint-disable-line

  async function loadOrders() {
    setLoading(true);
    const { data } = await supabase
      .from("orders")
      .select("*")
      .eq("store_id", storeId)
      .order("created_at", { ascending: false });
    setOrders(data || []);
    setLoading(false);
  }

  const filtered = filter === "all" ? orders : orders.filter(o => o.status === filter);

  const totalPaid = orders.filter(o => o.status === "paid").reduce((a, o) => a + Number(o.amount), 0);
  const totalPending = orders.filter(o => o.status === "pending").reduce((a, o) => a + Number(o.amount), 0);
  const conversionRate = orders.length > 0 ? Math.round((orders.filter(o => o.status === "paid").length / orders.length) * 100) : 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Pedidos</div>
          <div style={S.pageSub}>Acompanhe vendas geradas pelo agente</div>
        </div>
        <button style={{ ...S.btnSecondary, fontSize: 12 }} onClick={loadOrders}>↻ Atualizar</button>
      </div>

      <div style={S.section}>
        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Total recebido", value: fmt(totalPaid), icon: "💰", color: "var(--sale)" },
            { label: "Aguardando", value: fmt(totalPending), icon: "⏳", color: "var(--warn)" },
            { label: "Pedidos pagos", value: String(orders.filter(o => o.status === "paid").length), icon: "✅", color: "var(--info)" },
            { label: "Conversão", value: `${conversionRate}%`, icon: "📈", color: "var(--accent)" },
          ].map((s, i) => (
            <div key={i} style={{ ...S.card, animation: `fadeUp .2s ${i * 0.05}s both` }}>
              <div style={{ fontSize: 16, marginBottom: 8 }}>{s.icon}</div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 28, color: s.color, lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: 11, color: "var(--text2)", marginTop: 5 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Filtros */}
        <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap" }}>
          {["all", "paid", "pending", "cancelled"].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              style={{ padding: "4px 12px", borderRadius: 20, fontSize: 11, fontWeight: 500, cursor: "pointer", border: "1px solid", transition: "all .15s", fontFamily: "var(--font-body)",
                background: filter === f ? "var(--accent)" : "transparent",
                color: filter === f ? "#0a0b0e" : "var(--text3)",
                borderColor: filter === f ? "var(--accent)" : "var(--border)" }}>
              {f === "all" ? "Todos" : f === "paid" ? "Pagos" : f === "pending" ? "Aguardando" : "Cancelados"}
            </button>
          ))}
        </div>

        {/* Tabela */}
        <div style={{ ...S.card, padding: 0, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 160px 90px 110px 100px 80px", padding: "10px 16px", borderBottom: "1px solid var(--border)", background: "var(--bg3)" }}>
            {["Cliente", "Produto", "Valor", "Status", "Data", ""].map(h => (
              <div key={h} style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.5px" }}>{h}</div>
            ))}
          </div>

          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><Spinner /></div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", color: "var(--text3)" }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>📦</div>
              <div style={{ fontSize: 13 }}>Nenhum pedido ainda</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>Os pedidos gerados pelo agente aparecerão aqui</div>
            </div>
          ) : (
            filtered.map(o => {
              const st = ORDER_STATUS[o.status] || ORDER_STATUS.pending;
              return (
                <div key={o.id} style={{ display: "grid", gridTemplateColumns: "1fr 160px 90px 110px 100px 80px", padding: "12px 16px", borderBottom: "1px solid var(--border)", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text)" }}>{o.client_name || o.client_phone}</div>
                    <div style={{ fontSize: 11, color: "var(--text3)" }}>{o.client_phone?.replace("@s.whatsapp.net","").replace("@lid","")}</div>
                    {o.delivery_info && (
                      <div style={{ fontSize: 11, color: "var(--accent)", marginTop: 2, fontWeight: 600 }}>📦 {o.delivery_info}</div>
                    )}
                  </div>
                  <div>
                    <div style={{ fontSize: 12, color: "var(--text2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{o.product_name}</div>
                    <div style={{ fontSize: 10, color: "var(--text3)" }}>x{o.product_qty}</div>
                  </div>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--accent)" }}>{fmt(o.amount)}</div>
                  <div>
                    <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 8px", borderRadius: 20, background: st.bg, color: st.color, border: `1px solid ${st.color}` }}>
                      {st.label}
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>
                    {new Date(o.created_at).toLocaleDateString("pt-BR")}
                    <div>{new Date(o.created_at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}</div>
                  </div>
                  <div>
                    {o.conversation_id && (
                      <button style={{ ...S.btnSecondary, fontSize: 10, padding: "4px 8px" }}
                        onClick={() => onOpenConversation?.(o.conversation_id)}>
                        💬 Chat
                      </button>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}


// ─── HELP PAGE ────────────────────────────────────────────────────────────────
function HelpPage({ store, agent, products }) {
  const hasProduct = products.filter(p => p.active).length > 0;
  const hasAgent = !!(agent?.name);
  const hasWhatsApp = agent?.instance_status === "connected";
  const hasMp = !!(store?.mp_access_token);

  const checklist = [
    { done: hasProduct, label: "Cadastrar pelo menos 1 produto no Catálogo", tab: "products", icon: "📦" },
    { done: hasAgent, label: "Configurar o agente (nome, tom e instruções)", tab: "agent", icon: "🤖" },
    { done: hasWhatsApp, label: "Conectar o WhatsApp ao agente", tab: "agent", icon: "📱" },
    { done: hasMp, label: "Conectar o Mercado Pago para receber Pix", tab: "integrations", icon: "💳" },
  ];

  const done = checklist.filter(c => c.done).length;

  const sections = [
    {
      icon: "📦",
      title: "Catálogo",
      desc: "Cadastre os produtos ou serviços que seu agente vai vender.",
      items: [
        "Clique em Catálogo no menu e depois em '+ Novo produto'",
        "Preencha o nome, descrição e tipo de precificação",
        "Unitário com escala: ideal para produtos vendidos por unidade com preços que mudam por quantidade",
        "Pacotes fechados: ideal para atacado (ex: 100 balas = R$15, 500 balas = R$60)",
        "Adicione imagem e áudio opcionais — o agente envia automaticamente no WhatsApp",
        "Ative o produto para que o agente o conheça",
      ],
    },
    {
      icon: "🤖",
      title: "Agentes",
      desc: "Configure a personalidade e o comportamento do seu assistente virtual.",
      items: [
        "Defina o nome do agente (ex: Luna, Max, Sofia)",
        "Escolha o tom: amigável, formal, jovem, consultivo ou energético",
        "Defina o foco: vendas, suporte, triagem ou tudo",
        "Use as Instruções personalizadas para ensinar regras específicas (ex: 'ofereça 5% de desconto no Pix')",
        "No card do agente, clique em 'Conectar WhatsApp' e escaneie o QR Code",
        "Após conectar, o agente começa a responder automaticamente 24/7",
      ],
    },
    {
      icon: "💬",
      title: "Conversas",
      desc: "Acompanhe em tempo real todas as interações do WhatsApp.",
      items: [
        "Cada mensagem recebida no WhatsApp cria uma conversa automaticamente",
        "O agente classifica a conversa em: Triagem, Venda ou Suporte",
        "Use os filtros para ver conversas por estágio ou por agente",
        "Clique em uma conversa para ver o histórico completo de mensagens",
        "Marque como Resolvida quando o atendimento for concluído",
        "Conversas em tempo real — novas mensagens aparecem automaticamente",
      ],
    },
    {
      icon: "💳",
      title: "Pagamentos (Mercado Pago)",
      desc: "Receba pagamentos via Pix automaticamente no WhatsApp.",
      items: [
        "Vá em Integrações e clique em 'Conectar Mercado Pago'",
        "Acesse mercadopago.com.br/developers, crie uma aplicação e copie o Access Token de produção",
        "Cole o token no VendaAI e salve",
        "Configure o webhook na sua app MP: evento = Pagamentos, URL = fornecida no painel",
        "Cadastre uma chave Pix na sua conta Mercado Pago",
        "Pronto! Quando o cliente confirmar a compra, o agente gera o QR Code automaticamente",
        "Após o pagamento, o cliente recebe a confirmação automática no WhatsApp",
      ],
    },
    {
      icon: "📊",
      title: "Pedidos",
      desc: "Acompanhe todas as vendas geradas pelo agente.",
      items: [
        "Cada venda confirmada aparece na aba Pedidos automaticamente",
        "Status Aguardando: QR Code gerado, aguardando pagamento do cliente",
        "Status Pago: pagamento confirmado pelo Mercado Pago",
        "A coluna '📦 Entrega' mostra o @ ou dado de entrega coletado pelo agente",
        "Clique em '💬 Chat' para ver a conversa completa daquele pedido",
        "Os cards no topo mostram receita total, pedidos pagos e taxa de conversão",
      ],
    },
    {
      icon: "❓",
      title: "Perguntas frequentes",
      desc: "Dúvidas comuns sobre o VendaAI.",
      items: [
        "O agente não está respondendo: verifique se o WhatsApp está conectado na aba Agentes",
        "QR Code não gerou: confirme que o token MP está salvo e que há uma chave Pix cadastrada na conta MP",
        "Pagamento não confirmou: verifique se o webhook está configurado no painel MP com evento = Pagamentos",
        "O agente mencionou preço errado: revise os produtos no Catálogo e salve novamente",
        "Limite de mensagens atingido: faça upgrade do plano na tela de Dashboard",
        "WhatsApp desconectou: vá em Agentes e clique em 'Conectar WhatsApp' para reconectar",
      ],
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div style={S.pageHeader}>
        <div>
          <div style={S.pageTitle}>Ajuda</div>
          <div style={S.pageSub}>Guia completo do VendaAI</div>
        </div>
      </div>
      <div style={S.section}>

        {/* Checklist primeiros passos */}
        <div style={{ ...S.card, marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
            <div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15, color: "var(--text)" }}>🚀 Primeiros passos</div>
              <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 3 }}>{done}/4 concluídos</div>
            </div>
            <div style={{ width: 120, height: 6, background: "var(--bg3)", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${(done / 4) * 100}%`, background: done === 4 ? "var(--sale)" : "var(--accent)", borderRadius: 3, transition: "width .4s" }} />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {checklist.map((c, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", background: c.done ? "#0d1f0d" : "var(--bg3)", borderRadius: "var(--r)", border: `1px solid ${c.done ? "#1a3d1a" : "var(--border)"}`, transition: "all .2s" }}>
                <div style={{ width: 22, height: 22, borderRadius: "50%", background: c.done ? "var(--sale)" : "var(--bg4)", border: `2px solid ${c.done ? "var(--sale)" : "var(--border2)"}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 11, color: c.done ? "#0a0b0e" : "var(--text3)", fontWeight: 700 }}>
                  {c.done ? "✓" : i + 1}
                </div>
                <div style={{ flex: 1, fontSize: 13, color: c.done ? "var(--sale)" : "var(--text2)", textDecoration: c.done ? "none" : "none" }}>
                  {c.icon} {c.label}
                </div>
                {!c.done && (
                  <span style={{ fontSize: 11, color: "var(--accent)", background: "var(--bg4)", padding: "3px 8px", borderRadius: 20, border: "1px solid var(--border2)", whiteSpace: "nowrap" }}>
                    Pendente
                  </span>
                )}
              </div>
            ))}
          </div>
          {done === 4 && (
            <div style={{ marginTop: 12, padding: "10px 14px", background: "#0d1f0d", borderRadius: "var(--r)", border: "1px solid #1a3d1a", fontSize: 13, color: "var(--sale)", textAlign: "center" }}>
              🎉 Tudo configurado! Seu agente está pronto para vender 24/7.
            </div>
          )}
        </div>

        {/* Seções de ajuda */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {sections.map((sec, i) => (
            <details key={i} style={{ ...S.card, padding: 0, overflow: "hidden" }}>
              <summary style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 12, listStyle: "none", userSelect: "none" }}>
                <span style={{ fontSize: 20 }}>{sec.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)" }}>{sec.title}</div>
                  <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 2 }}>{sec.desc}</div>
                </div>
                <span style={{ fontSize: 12, color: "var(--text3)" }}>▾</span>
              </summary>
              <div style={{ padding: "0 20px 16px", borderTop: "1px solid var(--border)" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingTop: 14 }}>
                  {sec.items.map((item, j) => (
                    <div key={j} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                      <div style={{ width: 20, height: 20, borderRadius: "50%", background: "var(--bg3)", border: "1px solid var(--border2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "var(--accent)", flexShrink: 0, marginTop: 1 }}>{j + 1}</div>
                      <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>{item}</div>
                    </div>
                  ))}
                </div>
              </div>
            </details>
          ))}
        </div>

        {/* Suporte */}
        <div style={{ ...S.card, marginTop: 20, background: "transparent", border: "1px dashed var(--border2)", textAlign: "center", padding: "24px" }}>
          <div style={{ fontSize: 20, marginBottom: 8 }}>💬</div>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)", marginBottom: 6 }}>Precisa de ajuda?</div>
          <div style={{ fontSize: 13, color: "var(--text2)" }}>Entre em contato com nosso suporte pelo WhatsApp</div>
        </div>
      </div>
    </div>
  );
}

// ─── APP SHELL ────────────────────────────────────────────────────────────────
const NAV = [
  { id: "dashboard", icon: "◈", label: "Dashboard" },
  { id: "inbox", icon: "◍", label: "Conversas" },
  { id: "orders", icon: "◆", label: "Pedidos" },
  { id: "chat", icon: "◎", label: "Testar Agente" },
  { id: "products", icon: "▦", label: "Catálogo" },
  { id: "agent", icon: "◉", label: "Agentes" },
  { id: "integrations", icon: "⬡", label: "Integrações" },
  { id: "help", icon: "?", label: "Ajuda" },
];

export default function App() {
  const [user, setUser] = useState(null);
  const [store, setStore] = useState(null);
  const [agent, setAgent] = useState({ name: "Luna", tone: "amigável e objetivo", focus: "vendas e suporte", extra_instructions: "", selected_product_ids: null });
  const [products, setProducts] = useState([]);
  const [tab, setTab] = useState("dashboard");
  const [booting, setBooting] = useState(true);
  const [showTour, setShowTour] = useState(false);
  const isAdmin = store?.is_admin === true;
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [activeConvIdFromOrder, setActiveConvIdFromOrder] = useState(null);

  // Verifica sessão ao carregar
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) loadUserData(session.user);
      else setBooting(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) loadUserData(session.user);
      else { setUser(null); setStore(null); setBooting(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  async function loadUserData(u) {
    setUser(u);
    const { data: storeData } = await supabase.from("stores").select("*").eq("user_id", u.id).single();
    if (storeData) {
      setStore(storeData);
      // Tour desativado — substituído pela aba Ajuda
      const { data: agentData } = await supabase.from("agents").select("*").eq("store_id", storeData.id).order("created_at").limit(1).single();
      if (agentData) setAgent(agentData);
      const { data: productsData } = await supabase.from("products").select("*").eq("store_id", storeData.id).order("created_at");
      if (productsData) setProducts(productsData);
    }
    // is_admin vem direto do storeData
    setBooting(false);
  }

  async function logout() {
    await supabase.auth.signOut();
  }

  if (booting) return <><FontLink /><div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center" }}><Spinner size={32} /></div></>;
  if (!user) return <><FontLink /><AuthScreen onAuth={loadUserData} /></>;


  return (
    <>
      <FontLink />
      <div style={S.app}>
        <aside style={S.sidebar}>
          <div style={{ ...S.sidebarLogo, cursor: "pointer" }} onClick={() => setTab("dashboard")}>
            <div style={S.logoMark}>V</div>
            <span style={S.logoText}>VendaAI</span>
          </div>
          <div style={{ padding: "10px 8px" }}>
            <EditableStoreName store={store} onUpdate={name => setStore(s => ({ ...s, name }))} />
          </div>
          <nav style={S.nav}>
            {NAV.map(item => (
              <button id={`nav-${item.id}`} key={item.id} style={S.navItem(tab === item.id)} onClick={() => setTab(item.id)}>
                <span style={{ fontFamily: "monospace", fontSize: 16, width: 18, textAlign: "center", color: tab === item.id ? "var(--accent)" : "var(--text3)" }}>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
            {isAdmin && (
              <button style={{ ...S.navItem(tab === "admin"), borderLeft: tab === "admin" ? "2px solid var(--warn)" : "2px solid transparent", marginTop: 8 }} onClick={() => setTab("admin")}>
                <span style={{ fontFamily: "monospace", fontSize: 16, width: 18, textAlign: "center", color: tab === "admin" ? "var(--warn)" : "var(--text3)" }}>⚡</span>
                <span style={{ color: tab === "admin" ? "var(--warn)" : "var(--text2)" }}>Admin</span>
              </button>
            )}
          </nav>
          <div style={S.sidebarFooter}>
            <button style={S.btnLogout} onClick={logout}>Sair da conta</button>
          </div>
        </aside>

        <main style={S.main}>
          {tab === "admin" && isAdmin && <AdminPage />}
          {tab === "dashboard" && <DashboardPage products={products} agent={agent} store={store} onUpgrade={() => setShowUpgrade(true)} />}
          {tab === "inbox" && store && <InboxPage storeId={store.id} initialConvId={activeConvIdFromOrder} onConvOpened={() => setActiveConvIdFromOrder(null)} />}
          {tab === "orders" && store && <OrdersPage storeId={store.id} onOpenConversation={(convId) => { setTab("inbox"); setActiveConvIdFromOrder(convId); }} />}
          {tab === "chat" && store && <ChatPage agent={agent} products={products} storeName={store?.name || "sua loja"} storeId={store.id} />}
          {tab === "products" && store && <ProductsPage storeId={store.id} />}
          {tab === "agent" && store && <AgentPage storeId={store.id} plan={store.plan} products={products} />}
          {tab === "integrations" && store && <IntegrationsPage store={store} onUpdate={() => supabase.from("stores").select("*").eq("id", store.id).single().then(({data}) => data && setStore(data))} />}
          {tab === "help" && store && <HelpPage store={store} agent={agent} products={products} />}
        </main>
      </div>

      {showUpgrade && user && store && <UpgradeModal store={store} user={user} onClose={() => setShowUpgrade(false)} />}
    </>
  );
}
